<template>
  <div class="document-page document-detail">
    <v-row>
      <v-col cols="12" md="4">
        <span class="text-h4 mb-5 deep-purple--text">
          <!-- {{isUpdate?'แก้ไข':'สร้าง'}} -->{{ docType }}
        </span>

        <span class="deep-purple--text ml-10" v-if="form.number">
          <v-icon class="mb-2" color="deep-purple" left>mdi-file</v-icon>
          {{ form.number }}
        </span>
      </v-col>

      <v-col cols="12" class="text-right" md="8">
        <v-btn class="ml-5" small color="grey" outlined @click="close()">
          ปิดหน้าต่าง
        </v-btn>
        <v-btn
          class="ml-5"
          color="primary white--text"
          small
          @click="save()"
          :disabled="loading || !formHydrationReady"
          :loading="loading"
        >
          บันทึกข้อมูล
        </v-btn>

        <PrintDocument
          :key="printKey"
          v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 0"
          :docTypeId="docTypeId"
          :type="docType"
          :data="dataPrint.main_bill"
          :data2="dataPrint.split_bill"
          ref="printDocument"
          :disabled="!form.number"
          :firstCreated="true"
        >
          <v-btn
            class="ml-5"
            small
            color="primary"
            outlined
            :disabled="!form.number"
            :loading="loading"
          >
            พิมพ์ <v-icon right>mdi-printer</v-icon>
          </v-btn>
        </PrintDocument>

        <PrintDocument9inc
          :key="printKey"
          v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 2"
          :docTypeId="docTypeId"
          :type="docType"
          :data="dataPrint.main_bill"
          :data2="dataPrint.split_bill"
          ref="printDocument"
          :disabled="!form.number"
          :firstCreated="true"
        >
          <v-btn
            class="ml-5"
            small
            color="primary"
            outlined
            :disabled="!form.number"
            :loading="loading"
          >
            พิมพ์ <v-icon right>mdi-printer</v-icon>
          </v-btn>
        </PrintDocument9inc>

        <PrintDocument80mm
          :key="printKey"
          v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 1"
          :docTypeId="docTypeId"
          :type="docType"
          :data="dataPrint.main_bill"
          :data2="dataPrint.split_bill"
          ref="printDocument"
          :disabled="!form.number"
          :firstCreated="true"
        >
          <v-btn
            class="ml-5"
            small
            color="primary"
            outlined
            :disabled="!form.number"
            :loading="loading"
          >
            พิมพ์ <v-icon right>mdi-printer</v-icon>
          </v-btn>
        </PrintDocument80mm>

        <PrintDocumentFull
          :key="printKey"
          v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 3"
          :docTypeId="docTypeId"
          :type="docType"
          :data="dataPrint.main_bill"
          :data2="dataPrint.split_bill"
          ref="printDocument"
          :disabled="!form.number"
        >
          <v-btn
            class="ml-5"
            small
            color="primary"
            outlined
            :disabled="!form.number"
            :loading="loading"
          >
            พิมพ์ <v-icon right>mdi-printer</v-icon>
          </v-btn>
        </PrintDocumentFull>

        <v-btn
          class="ml-5"
          small
          color="error"
          outlined
          @click="overdue()"
          :disabled="
            form.status != 0 || !isEdit || !$route.params.id || loading
          "
          :loading="loading"
        >
          ค้างชำระ
        </v-btn>
        <v-btn
          class="ml-5"
          small
          color="error"
          @click="pay()"
          :disabled="
            form.status != 0 || !isEdit || !$route.params.id || loading
          "
          :loading="loading"
        >
          ชำระเงิน
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="loading">
      <v-progress-linear color="deep-purple" class="text-center text-h6 white--text py-5" indeterminate :height="60">กำลังโหลดข้อมูล กรุณาคอยสักครู่... </v-progress-linear>
    </div>
    <div v-if="!loading" :inert="formHydrationReady ? null : ''" :class="{ 'document-form-hydrating': !formHydrationReady }">
      <v-row>
        <v-col cols="12" md="2">
          <CustomerDisplayButton
            :online="customerDisplayOnline"
            :show-reminder="customerDisplayShowReminder"
            @click="toggleCustomerDisplay"
          />
        </v-col>
        
        <v-col cols="12" class="text-right" md="10">
          <span class="text-h4 dark--text mr-5">รวมจำนวนเงินทั้งสิ้น</span>
          <span class="text-h2 deep-purple--text">{{
            net_price | numeral('0,0.00')
          }}</span>
        </v-col>

        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="approvals"
            :items="list.approval"
            :search-input.sync="form.approval"
            return-object
            item-text="name"
            item-value="_id"
            outlined
            dense
            label="ชื่อพนักงาน"
            autocomplete="off"
            @change="
              (val) => {
                getApprovalById(val._id);
              }
            "
            auto-select-first
            hide-details
            @keydown="handleApproval()"
            :disabled="isUpdate"
            class="mb-6"
          >
            <template slot="item" slot-scope="{ item }">
              {{ item.name }}</template
            >
          </v-autocomplete>

          <v-text-field
            name="project_name"
            v-model="form.project_name"
            label="ชื่อโปรเจ็ค"
            outlined
            dense
            autocomplete="on"
            ><template v-slot:append-outer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                </template>
                ใส่ในกรณีที่เป็นงานพิเศษ ไม่ใช่งานที่ลูกค้าทำบ่อยๆ เช่น โอน ย้าย
                หรือ ป.1 มิตรแท้ เป็นต้น
                โน๊ตนี้จะไปแสดงหลังเลขทะเบียนรถในหน้าตารางของเอกสาร
                และในใบเสร็จที่ปริ้นออกมา
              </v-tooltip>
            </template>
          </v-text-field>
          <!-- :error-messages="$v.form.project_name.$error ? $error_text : ''" -->
        </v-col>

        <v-col offset="0" offset-md="5" cols="12" md="4">
          <v-row>
            <v-col cols="5">
              <v-row class="border-white" dense>
                <v-col cols="12">วันที่ออกใบ</v-col>
                <v-col cols="12">วันครบกำหนด</v-col>
              </v-row>
            </v-col>
            <v-col cols="7">
              <v-row class="border-grey" dense>
                <v-col cols="6">
                  <v-menu
                    ref="menu_date_of_issue"
                    v-model="menu.date_of_issue"
                    :close-on-content-click="false"
                    :return-value.sync="form.date_of_issue"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ formatDate(form.date_of_issue) }}
                      </span>
                    </template>
                    <v-date-picker
                      v-model="form.date_of_issue"
                      no-title
                      scrollable
                      locale="th"
                      @change="onDateOfIssueChange"
                    />
                  </v-menu>
                  <!-- {{ formatDate(form.date_of_issue) }} -->
                </v-col>
                <v-col cols="6" class="pl-5">
                  {{ form.date_of_issue | moment($formatTime) }}
                </v-col>
                <v-col cols="12">
                  <v-menu
                    ref="menu_due_date"
                    v-model="menu.due_date"
                    :close-on-content-click="false"
                    :return-value.sync="form.due_date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="isUpdate"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ formatDate(form.due_date) }}
                      </span>
                    </template>
                    <v-date-picker
                      v-model="form.due_date"
                      no-title
                      scrollable
                      locale="th"
                      @change="$refs.menu_due_date.save(form.due_date)"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-text class="px-5">
              <v-row class="pa-0">
                <v-col cols="12" md="3">
                  <div class="text-h5 deep-purple--text">1. ข้อมูลรถ</div>
                </v-col>
                <v-col cols="12" md>
                  <span
                    class="layout-upload pointer primary--text"
                    @click="
                      (dialogEditDocumentData = {
                        document_id: form._id,
                        plate_character: temp_car.plate_character,
                        plate_number: temp_car.plate_number,
                        car_plate:
                          temp_car.plate_character +
                          ' ' +
                          temp_car.plate_number,
                        car_province: form.car_plate_province,
                        customer_phone_number: form.customer_phone_number,
                      }),
                        (dialogEditCar = true)
                    "
                    v-if="isUpdate"
                  >
                    <div
                      class="primary--text subtitle-1 text-decoration-underline"
                    >
                      กดแก้ไขเลขทะเบียน
                    </div>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="หมวดอักษร"
                    v-model="temp_car.plate_character"
                    @keyup="handleCarsInfo()"
                    outlined
                    dense
                    autocomplete="off"
                    @keypress.native="carPlateCharacter"
                    @focus="$event.target.select()"
                    :hide-details="!$v.form.car_plate_character.$error"
                    :error-messages="
                      $v.form.car_plate_character.$error ? $error_empty : ''
                    "
                    :disabled="form.isEdit || isUpdate"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="เลขทะเบียน"
                    v-model="temp_car.plate_number"
                    @keyup="handleCarsInfo()"
                    outlined
                    dense
                    autocomplete="off"
                    @keypress.native="carNumber"
                    @focus="$event.target.select()"
                    @blur="plateNumberTouched = true"
                    hide-details="auto"
                    :error-messages="
                      plateNumberTouched && !temp_car.plate_number
                        ? 'กรอกได้เฉพาะตัวเลข ไม่เกิน 5 หลัก'
                        : ($v.form.car_plate_number.$error ? $error_empty : '')
                    "
                    :disabled="form.isEdit || isUpdate"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    v-model="temp_car.plate_province"
                    :items="list.provinces"
                    @change="
                      (val) => {
                        handleCarsInfo();
                      }
                    "
                    outlined
                    dense
                    label="จังหวัด"
                    :hide-details="!$v.form.car_plate_province.$error"
                    :error-messages="
                      $v.form.car_plate_province.$error ? $error_empty : ''
                    "
                    :disabled="form.isEdit || isUpdate"
                  ></v-select>
                </v-col>

                <!-- <v-col cols="12" class="text-center py-0" v-if="carSearching">
                  <span>กำลังค้นหาข้อมูล กรุณารอสักครู่</span>
                </v-col> -->

                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_type == 'CT1' && form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_type != 'CT1'"
                    @click="form.car_type = 'CT1'"
                    :disabled="isUpdate || carSearching"
                  >
                    รย.1<span v-if="form.car_type == 'CT1' && form.car_fuel == 3"> EV</span>
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_type == 'CT2' && form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_type != 'CT2'"
                    @click="form.car_type = 'CT2'"
                    :disabled="isUpdate || carSearching"
                  >
                    รย.2<span v-if="form.car_type == 'CT2' && form.car_fuel == 3"> EV</span>
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_type == 'CT3' && form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_type != 'CT3'"
                    @click="form.car_type = 'CT3'"
                    :disabled="isUpdate || carSearching"
                  >
                    รย.3<span v-if="form.car_type == 'CT3' && form.car_fuel == 3"> EV</span>
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_type == 'CT12' && form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_type != 'CT12'"
                    @click="form.car_type = 'CT12'"
                    :disabled="isUpdate || carSearching"
                  >
                    รย.12<span v-if="form.car_type == 'CT12' && form.car_fuel == 3"> EV</span>
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_type == 'CT13' && form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_type != 'CT13'"
                    @click="form.car_type = 'CT13'"
                    :disabled="isUpdate || carSearching"
                  >
                    รย.13<span v-if="form.car_type == 'CT13' && form.car_fuel == 3"> EV</span>
                  </v-btn>
                </v-col>

                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_type == 'CT17' && form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_type != 'CT17'"
                    @click="form.car_type = 'CT17'"
                    :disabled="isUpdate || carSearching"
                  >
                    รย.17<span v-if="form.car_type == 'CT17' && form.car_fuel == 3"> EV</span>
                  </v-btn>
                </v-col>

                <v-col cols="12" md="10">
                  <v-select
                    item-value="value"
                    item-text="name"
                    v-model="form.car_type"
                    label="ประเภทรถ"
                    :items="list.car_type_dict"
                    :menu-props="{ maxHeight: '400' }"
                    outlined
                    dense
                    :hide-details="!$v.form.car_type.$error"
                    :error-messages="
                      $v.form.car_type.$error ? $error_empty : ''
                    "
                    :disabled="isUpdate || carSearching"
                  ></v-select>
                </v-col>

                <v-col cols="6" sm="4" class="d-flex align-center" md="2">
                  <v-btn
                    small
                    block
                    :color="form.car_fuel == 3 ? 'orange white--text' : 'primary white--text'"
                    :outlined="form.car_fuel != 3"
                    @click="toggleElectricFuel()"
                    :disabled="loading || carSearching || form.status != 0"
                  >
                    รถไฟฟ้า
                  </v-btn>
                </v-col>

                <v-col cols="12" class="py-0" v-if="form.car_fuel == 3">
                  <span class="orange--text">รถคันนี้เป็นรถไฟฟ้า 100%</span>
                </v-col>

                <v-col cols="12" class="mt-n4">
                  <v-checkbox
                    v-model="detailCar"
                    label="ไม่เก็บรายละเอียดรถ (ซีซี วันจด เพราะ ตรวจสภาพอย่างเดียว เป็นต้น)"
                    color="info"
                    hide-details
                    :disabled="isUpdate"
                  />
                </v-col>
              </v-row>

              <v-row v-if="form.car_type == 'CT2' && form.car_fuel != 3" class="py-2">
                  <v-col cols="12" class="pb-0">
                    <div>ปุ่มด่วนเลือก น้ำหนัก (ถ้าไม่มี กรุณากรอกในช่อง)</div>
                  </v-col>
                  <v-col cols="6" sm="4" class="pb-0" md="2">
                    <v-btn
                      small
                      color="primary white--text"
                      :outlined="form.car_weight != 1600"
                      @click="setQuickCarSpecification('car_weight', 1600)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,600กก
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="primary white--text"
                      :outlined="form.car_weight != 1800"
                      @click="setQuickCarSpecification('car_weight', 1800)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,800กก
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="primary white--text"
                      :outlined="form.car_weight != 1850"
                      @click="setQuickCarSpecification('car_weight', 1850)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,850กก
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="primary white--text"
                      :outlined="form.car_weight != 1900"
                      @click="setQuickCarSpecification('car_weight', 1900)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,900กก
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="primary white--text"
                      :outlined="form.car_weight != 2100"
                      @click="setQuickCarSpecification('car_weight', 2100)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      2,100กก
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="primary white--text"
                      :outlined="form.car_weight != 2200"
                      @click="setQuickCarSpecification('car_weight', 2200)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      2,200กก
                    </v-btn>
                  </v-col>
              </v-row>

              <v-row v-if="form.car_type == 'CT3' && form.car_fuel != 3" class="py-2">
                <v-col cols="12" class="pb-0">
                  <div>ปุ่มด่วนเลือก น้ำหนัก (ถ้าไม่มี กรุณากรอกในช่อง)</div>
                </v-col>
                <v-col cols="6" sm="4" class="pb-0" md="2">
                  <v-btn
                    small
                    color="primary white--text"
                    :outlined="form.car_weight != 1400"
                    @click="setQuickCarSpecification('car_weight', 1400)"
                    :disabled="loading || (isUpdate && form.status != 0)"
                  >
                    1,400กก
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    color="primary white--text"
                    :outlined="form.car_weight != 1450"
                    @click="setQuickCarSpecification('car_weight', 1450)"
                    :disabled="loading || (isUpdate && form.status != 0)"
                  >
                    1,450กก
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    color="primary white--text"
                    :outlined="form.car_weight != 1500"
                    @click="setQuickCarSpecification('car_weight', 1500)"
                    :disabled="loading || (isUpdate && form.status != 0)"
                  >
                    1,500กก
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    color="primary white--text"
                    :outlined="form.car_weight != 1550"
                    @click="setQuickCarSpecification('car_weight', 1550)"
                    :disabled="loading || (isUpdate && form.status != 0)"
                  >
                    1,550กก
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    color="primary white--text"
                    :outlined="form.car_weight != 1600"
                    @click="setQuickCarSpecification('car_weight', 1600)"
                    :disabled="loading || (isUpdate && form.status != 0)"
                  >
                    1,600กก
                  </v-btn>
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-btn
                    small
                    color="primary white--text"
                    :outlined="form.car_weight != 1700"
                    @click="setQuickCarSpecification('car_weight', 1700)"
                    :disabled="loading || (isUpdate && form.status != 0)"
                  >
                    1,700กก
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="detailCar == true">
                <v-col cols="12" md="6">
                  <v-text-field
                    name="car_weight"
                    :value="formatCarSpecification('car_weight')"
                    label="น้ำหนักรถเปล่า (กก.)"
                    outlined
                    dense
                    hide-details
                    autocomplete="off"
                    :disabled="isUpdate && !allowElectricVehicleWeightCorrection"
                    @input="updateCarSpecification('car_weight', $event)"
                    @keypress.native="carWeightNumber"
                    @focus="focusCarSpecification('car_weight', $event)"
                    @blur="blurCarSpecification()"
                  />
                  <div class="error--text">{{ errors.car_weight }}</div>
                </v-col>
              </v-row>

              <v-row v-if="detailCar == false">
                <v-row v-if="form.car_type == 'CT1' && form.car_fuel != 3" class="py-2">
                  <v-col cols="12" class="pb-0">
                    <div>ปุ่มด่วนเลือก ซีซี (ถ้าไม่มี กรุณากรอกในช่อง)</div>
                  </v-col>
                  <v-col cols="6" sm="4" class="pb-0" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 1198"
                      @click="setQuickCarSpecification('engine_size', 1198)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,198cc
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 1497"
                      @click="setQuickCarSpecification('engine_size', 1497)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,497cc
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 1598"
                      @click="setQuickCarSpecification('engine_size', 1598)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,598cc
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 1798"
                      @click="setQuickCarSpecification('engine_size', 1798)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,798cc
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 1998"
                      @click="setQuickCarSpecification('engine_size', 1998)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      1,998cc
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 2499"
                      @click="setQuickCarSpecification('engine_size', 2499)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      2,499cc
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row v-if="form.car_type === 'CT12' || form.car_type === 'CT17'" class="py-2">
                  <v-col cols="12" class="pb-0">
                    <div>ปุ่มด่วนเลือก ซีซี (ถ้าไม่มี กรุณากรอกในช่อง)</div>
                  </v-col>
                  <v-col cols="6" sm="4" class="pb-0" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 97"
                      @click="setQuickCarSpecification('engine_size', 97)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      97 ซีซี
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 109"
                      @click="setQuickCarSpecification('engine_size', 109)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      109 ซีซี
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 115"
                      @click="setQuickCarSpecification('engine_size', 115)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      115 ซีซี
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 125"
                      @click="setQuickCarSpecification('engine_size', 125)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      125 ซีซี
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 149"
                      @click="setQuickCarSpecification('engine_size', 149)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      149 ซีซี
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="4" md="2">
                    <v-btn
                      small
                      color="success white--text"
                      :outlined="form.engine_size != 155"
                      @click="setQuickCarSpecification('engine_size', 155)"
                      :disabled="loading || (isUpdate && form.status != 0)"
                    >
                      155 ซีซี
                    </v-btn>
                  </v-col>
                </v-row>

                <v-col cols="12" md="6">
                  <v-text-field
                    name="car_weight"
                    :value="formatCarSpecification('car_weight')"
                    label="น้ำหนักรถเปล่า (กก.)"
                    outlined
                    dense
                    hide-details
                    autocomplete="off"
                    :disabled="isUpdate && !allowElectricVehicleWeightCorrection"
                    @input="updateCarSpecification('car_weight', $event)"
                    @keypress.native="carWeightNumber"
                    @focus="focusCarSpecification('car_weight', $event)"
                    @blur="blurCarSpecification()"
                  />
                  <div class="error--text">{{ errors.car_weight }}</div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    name="engine_size"
                    :value="formatCarSpecification('engine_size')"
                    label="เครื่องยนต์ (CC)"
                    outlined
                    dense
                    hide-details
                    autocomplete="off"
                    :disabled="isUpdate"
                    @input="updateCarSpecification('engine_size', $event)"
                    @keypress.native="engineNumber"
                    @focus="focusCarSpecification('engine_size', $event)"
                    @blur="blurCarSpecification()"
                  />
                  <div class="error--text">{{ errors.engine_size }}</div>
                </v-col>

                <v-col cols="12" md="4">
                  <DatePicker
                    label="วันจดทะเบียน"
                    datepicker_type="YEAR"
                    :value="form.registration_date"
                    @onChange="
                      (val) => (
                        (form.registration_date = val),
                        calculateTaxOutDate(val),
                        (isEditFilterExpressProduct = true)
                      )
                    "
                    hideDetails
                    :maxDate="current_date"
                    :disabled="isUpdate"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <DatePicker
                    label="วันที่ภาษีเก่าขาด"
                    datepicker_type="YEAR"
                    :value="form.taxout_date"
                    @onChange="
                      (val) => (
                        (isEditFilterExpressProduct = true),
                        (dialogYearChooseData = form.taxout_date),
                        (form.taxout_date = val),
                        (form.bill_taxout_date = val),
                        main_calculate()
                      )
                    "
                    hideDetails
                    :maxDate="max_taxout_date"
                    :disabled="isUpdate"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn
                    class="mt-2"
                    color="primary white--text"
                    :value="form.taxout_date"
                    outlined
                    small
                    :disabled="isUpdate"
                    @click="
                      (dialogYearChoose = true),
                        (dialogYearChooseData = form.taxout_date)
                    "
                    hideDetails
                  >
                    เลือกปีภาษีเก่าขาด
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <DatePicker
                    label="วันที่จะยื่นต่อภาษี"
                    :value="form.tax_filling_date"
                    @onChange="
                      (val) => (
                        (form.tax_filling_date = val),
                        calculatePickupDate(val),
                        (isActiveTaxYearEnd = false),
                        (isEditFilterExpressProduct = true),
                        main_calculate()
                      )
                    "
                    hideDetails
                    :disabled="isUpdate"
                  />
                </v-col>
                <v-col cols="12" class="d-flex" md="6">
                  <div v-if="taxRenewalEndYear">
                    <div v-if="!car_tax.total_tax_price[3]" class="black--text my-1">
                      รถอายุ {{ carAgeYears }} ปี • จะต่อภาษีปีที่
                      {{ taxRenewalYears.join(', ') }} • ต่อถึงปี
                      <span class="primary--text font-weight-bold">
                        {{ taxRenewalEndYear }}
                      </span>
                    </div>
                    <template v-else>
                      <div class="black--text my-1">
                        รถอายุ {{ carAgeYears }} ปี • จะต่อภาษีปีที่
                        {{ taxRenewalYearNumber }}, {{ taxRenewalYearNumber + 1 }}
                      </div>
                      <div class="black--text my-1">
                        ต้องการต่อถึงปีไหน ? (สีทึบ คือปีที่จะต่อ)
                      </div>
                      <v-btn
                        class="ml-5"
                        color="error"
                        :outlined="!isActiveTaxYearInit"
                        @click="handleTaxYearSelection(false)"
                      >
                        {{ car_tax.total_tax_price[1] + 543 }}
                      </v-btn>
                      <v-btn
                        class="ml-5"
                        color="error"
                        :outlined="!isActiveTaxYearEnd"
                        @click="handleTaxYearSelection(true)"
                      >
                        {{ car_tax.total_tax_price[3] + 543 }}
                      </v-btn>
                    </template>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-radio-group
                    class="mt-0"
                    row
                    dense
                    v-model="form.is_original_document"
                    hide-details
                    :disabled="isUpdate"
                  >
                    <div class="mr-1">ชนิดเอกสาร :</div>
                    <v-radio
                      class="mr-1"
                      label="สำเนา"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      class="mr-0"
                      label="เล่มจริง"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <!-- <v-radio-group
                  class="mt-0 mb-2"
                  row
                  dense
                  v-model="form.car_fuel"
                  hide-details
                  :disabled="isUpdate"
                >
                  <div class="mr-1">เชื้อเพลิงหลัก  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" small v-bind="attrs" v-on="on"
                        >mdi-information</v-icon
                        >
                      </template>
                    <span>เก็บไว้เป็นประวัติรถ และใช้แสดงในรายงานควันดำ</span>
                      </v-tooltip>
                  :</div>
                  <v-radio @click="isEditFilterExpressProduct = true;" label="ไม่ระบุ" :value="0"></v-radio>
                  <v-radio @click="isEditFilterExpressProduct = true;" label="ดีเซล" :value="1"></v-radio>
                  <v-radio @click="isEditFilterExpressProduct = true;" label="เบนซิน" :value="2"></v-radio>
                  <v-radio @click="isEditFilterExpressProduct = true;" label="ไฟฟ้า 100%" :value="3"></v-radio>
                  <v-radio @click="isEditFilterExpressProduct = true;" label="อื่นๆ" :value="4"></v-radio>
                </v-radio-group> -->
                  <v-checkbox
                      class="mt-0"
                      v-model="form.is_corporation_car"
                      label="จดนิติบุคคล (รย.1 ภาษีรถ x 2)"
                      :disabled="isUpdate"
                      @change="handleCorporationCarChange"
                    />
                  <div
                    v-if="form.car_fuel != 3"
                    class="pt-0 mb-2"
                  >
                    <div class="mb-2">เชื้อเพลิงเสริม (ถ้ามีต้องเลือกด้วย มีผลกับการคิดค่าภาษีรถ)</div>
                    <div class="d-flex align-center flex-wrap">
                    <v-btn
                      :color="form.extra_fuel == 1 ? '#E0E0E0' : 'white'"
                      class="mx-2"
                      @click="toggleExtraFuel(1)"
                      :disabled="loading || form.status != 0"
                    >
                      <span class="green--text">CNG</span>
                    </v-btn>
                    <v-btn
                      :color="form.extra_fuel == 2 ? '#E0E0E0' : 'white'"
                      class="mx-2"
                      @click="toggleExtraFuel(2)"
                      :disabled="loading || form.status != 0"
                    >
                      <span class="blue--text"> LPG</span>
                    </v-btn>
                    <v-btn
                      :color="form.extra_fuel == 3 ? '#E0E0E0' : 'white'"
                      class="mx-2"
                      @click="toggleExtraFuel(3)"
                      :disabled="loading || form.status != 0"
                    >
                      <span class="mr-1 cyan--text">CNG</span>
                      <span class="grey--text">100%</span>
                    </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md>
          <v-card outlined>
            <v-card-text class="px-5">
              <v-row>
                <div class="text-h5 deep-purple--text mt-4 mb-1 mr-5">
                  2. ข้อมูลลูกค้า
                </div>
                <v-checkbox
                  v-model="detailCustomer"
                  label="ไม่เก็บประวัติลูกค้า"
                  color="info"
                  hide-details
                  :disabled="isUpdate"
                  @change="showCustomer()"
                />
                <span
                  class="layout-upload pointer mt-4 mb-1 ml-2 mr-5"
                  @click="
                    (dialogEditDocumentData = {
                      document_id: form._id,
                      customer_name: form.customer_name,
                      customer_address: form.customer_address,
                      customer_is_delivery_address:
                        form.customer_is_delivery_address,
                      customer_delivery_address: form.customer_delivery_address,
                      customer_phone_number: form.customer_phone_number,
                      customer_taxpayer_number: form.customer_taxpayer_number,
                      customer_company_branch: form.customer_company_branch,
                      customer_note: form.customer_note,
                      discounted_groups_id: form.discounted_groups_id,
                      call_alert: form.call_alert,
                      call_remind_renewal: form.call_remind_renewal,
                    }),
                      (dialogEditCustomer = true)
                  "
                  v-if="isUpdate"
                >
                  <div
                    class="ml-5 primary--text subtitle-1 text-decoration-underline"
                  >
                    กดแก้ไขชื่อลูกค้า
                  </div>
                </span>
              </v-row>
              <v-row v-if="detailCustomer == false">
                <v-col cols="12" class="pb-0" md="6">
                  <v-autocomplete
                    v-model="customer"
                    :items="list.filter_customers"
                    :search-input.sync="customer_name_search"
                    return-object
                    item-text="name"
                    item-value="_id"
                    outlined
                    dense
                    label="ชื่อลูกค้า (พิมพ์ชื่อได้เลยค่า)"
                    autocomplete="off"
                    @change="handleCustomerSelection"
                    auto-select-first
                    :disabled="isUpdate"
                    :hide-details="!$v.form.customer_name.$error"
                    :error-messages="
                      $v.form.customer_name.$error ? 'กรุณากรอกข้อมูล' : ''
                    "
                    @keydown="preventLeadingSpace"
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.name }}{{ item._id ? ' (ข้อมูลในระบบ)' : '' }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="pb-0" md="6">
                  <v-text-field
                    class="text-color"
                    :class="{ 'as-password': !toggleShowPhoneNumber }"
                    name="customer_phone_number"
                    id="customer_phone_number"
                    v-model="form.customer_phone_number"
                    label="เบอร์โทร"
                    autocomplete="new-password"
                    outlined
                    dense
                    :reverse="false"
                    hide-details
                    :disabled="isUpdate"
                    @keypress.native="isNumber"
                    @keydown="preventDelete"
                    @input="parsePhonePattern"
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <div class="text-center text-md-body-1">
                    รายละเอียดลูกค้าข้างล่างไม่จำเป็นต้องกรอกก็ได้
                    ถ้าไม่ต้องการเก็บ
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    name="customer_taxpayer_number"
                    v-model="form.customer_taxpayer_number"
                    label="เลขที่เสียภาษี"
                    outlined
                    dense
                    :disabled="isUpdate"
                    hide-details
                    @keypress.native="taxNumber"
                    autocomplete="off"
                  />
                  <v-checkbox
                    :input-value="!form.hide_customer_tax_id"
                    label="แสดงเลขนี้ในเอกสาร"
                    dense
                    hide-details
                    :disabled="updatingCustomerTaxIdVisibility"
                    @change="onCustomerTaxIdVisibilityChange"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    name="customer_address"
                    label="ที่อยู่"
                    outlined
                    dense
                    autocomplete="off"
                    @click="
                      (dialogAddressData = form.customer_address),
                        (dialogAddress = true),
                        (dialogAddressKey = 'customer_address')
                    "
                    :value="`${form.customer_address.address} ${form.customer_address.sub_district} ${form.customer_address.district} ${form.customer_address.province} ${form.customer_address.postal_code}`"
                    hide-details
                    :disabled="isUpdate"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    name="customer_company_branch"
                    v-model="form.customer_company_branch"
                    label="สาขา"
                    outlined
                    dense
                    hide-details
                    :disabled="isUpdate"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-textarea
                    name="customer_note"
                    v-model="form.customer_note"
                    label="หมายเหตุลูกค้า"
                    outlined
                    dense
                    rows="3"
                    hide-details
                    :disabled="isUpdate"
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="form.discounted_groups_id"
                    label="กลุ่มลูกค้า/ตัวแทน"
                    outlined
                    :items="list.discounted_groups"
                    dense
                    hide-details
                    item-text="name"
                    item-value="_id"
                    @change="
                      () => {
                        getProduct();
                        filterAndSetThirdInsuranceForm(form.product[0]);
                        filterAndSetInsuranceForm(form.product[1]);
                      }
                    "
                    :disabled="isUpdate"
                  ></v-select>
                </v-col>

                <v-col cols="12" class="d-flex mb-0 pb-0">
                  <v-checkbox
                    class="mt-0"
                    v-model="form.is_delivery_address"
                    :disabled="isUpdate"
                    dense
                  />
                  <v-text-field
                    name="customer_delivery_address"
                    label="ที่อยู่จัดส่ง"
                    outlined
                    dense
                    autocomplete="off"
                    @click="
                      (dialogAddressData = form.customer_delivery_address),
                        (dialogAddress = true),
                        (dialogAddressKey = 'customer_delivery_address')
                    "
                    :value="`${form.customer_delivery_address.address} ${form.customer_delivery_address.sub_district} ${form.customer_delivery_address.district} ${form.customer_delivery_address.province} ${form.customer_delivery_address.postal_code}`"
                    hide-details
                    :disabled="isUpdate"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    class="mt-0"
                    v-model="form.call_alert"
                    label="โทรแจ้งเมื่องานเสร็จ"
                    :disabled="isUpdate"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    class="mt-0"
                    v-model="form.call_remind_renewal"
                    label="โทรเตือนต่ออายุ"
                    :disabled="isUpdate"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div v-if="hasCarTaxPopupMessage" class="mt-4">
            <v-alert
              v-for="(message, index) in car_tax.popup_massage"
              v-if="message"
              :key="index"
              :type="getCarTaxPopupType(index, message)"
              dense
              outlined
              class="mb-2 font-weight-medium"
            >
              {{ message }}
            </v-alert>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-10">
        <v-col v-if="vehiclePriceChangeNotice" cols="12">
          <v-alert type="error" outlined prominent class="mb-0">
            ราคามีการเปลี่ยน เพราะข้อมูลรถเปลี่ยนแปลง
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-card outlined>
            <v-card-text class="px-5">
              <div class="text-h5 deep-purple--text mb-5">3. ข้อมูลสินค้า</div>
              <div>
                <span class="document-product-instruction"><span class="text-h6">เลือกสินค้าด่วน</span>
                (ใช้ได้กับ รย.1 รย.2 รย.3 รย.12 และ รย.17 เท่านั้น
                รย.อื่นๆ ต้องเลือกสินค้าเอง)</span>
                <span class="float-right document-pickup-schedule">
                  <span class="d-flex document-pickup-fields">
                  <DatePicker
                    label="วันนัดรับเอกสาร"
                    :value="form.pick_up_date"
                    @onChange="onPickupDateChange"
                  />
                  <PickupTimePicker
                    label="เวลารับ"
                    :value="form.pick_up_time"
                    :start-time="list.setting ? list.setting.document_pickup_time : ''"
                    @onChange="onPickupTimeChange"
                  />
                  <v-checkbox
                    class="pt-0 mx-4"
                    label="แสดงวันนัดรับงาน"
                    :input-value="form.show_pickup"
                    @change="onPickupVisibilityChange"
                  />
                  </span>
                  <div
                    v-if="canQuickSavePickupSchedule && pickupScheduleSaveMessage"
                    class="text-right caption mt-n4 mb-2 mr-4"
                    :class="pickupScheduleSaveState === 'error' ? 'error--text' : 'success--text'"
                  >
                    {{ pickupScheduleSaveMessage }}
                  </div>
                </span>
              </div>
              <v-row class="full-width-row">
                <v-col cols="12" md="8">
                  <v-row>
                    <v-col cols="12" v-if="showProductCheckbox" md="7">
                      <div>
                        <v-checkbox
                          class="mt-0"
                          :value="product_all"
                          v-model="product_all"
                          @change="handleProductAllChecked"
                          label="ทำทุกอย่าง"
                          :disabled="isUpdate"
                        />
                      </div>
                      <div class="ml-5 d-flex">
                        <div>
                          <v-checkbox
                            class="mr-5 mt-0"
                            value="inspect"
                            v-model="product_selected"
                            @change="handleProductChecked('inspect')"
                            label="ตรวจสภาพรถ"
                            :disabled="isUpdate"
                          />
                        </div>
                        <v-checkbox
                          class="mr-5 mt-0"
                          value="third_insurand"
                          v-model="product_selected"
                          @change="handleProductChecked('third_insurand')"
                          label="พ.ร.บ."
                          :disabled="isUpdate"
                        />
                        <v-checkbox
                          class="mr-5 mt-0"
                          value="tax"
                          v-model="product_selected"
                          @change="handleProductChecked('tax')"
                          label="ค่าภาษี"
                          :disabled="isUpdate"
                        />
                        <v-checkbox
                          v-if="this.$store.state.selected_branch._id === 'BR20220624143058897611d7x'"
                          class="mr-5 mt-0"
                          v-model="isUrgent"
                          @change="handleUrgentChecked"
                          label="ด่วน"
                          :disabled="isUpdate"
                        /></div
                    ></v-col>
                    <v-col cols="12" md="5">
                      <div
                        class="subtitle-2 deep-purple--text mb-5"
                        v-if="car.third_insurance_company || car.insurance_type"
                      >
                        <tr>
                          ข้อมูลเก่าในระบบ
                        </tr>
                        <tr v-if="car.third_insurance_company">
                          พรบ. =
                          {{
                            car.third_insurance_company +
                            ' ' +
                            formatDate(car.third_insurance_start_date) +
                            '-' +
                            formatDate(car.third_insurance_end_date)
                          }}
                        </tr>
                        <tr v-if="car.insurance_type">
                          ประกันภัย =
                          {{
                            car.insurance_type +
                            ' ' +
                            formatDate(car.insurance_start_date) +
                            '-' +
                            formatDate(car.insurance_end_date)
                          }}
                        </tr>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-row align="center">
                        <v-col cols="12" justify="end" class="px-0" md="5">
                          <span>คำนวนค่าประเมินรถ</span>
                        </v-col>
                        <v-col cols="12" md="7">
                          <span>
                            <v-text-field
                              class="textfield-w150"
                              outlined
                              dense
                              @change="handleEstimateCost"
                              :value="estimateCost | numeral('0,0')"
                              hide-details
                              suffix="บาท"
                            />
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="align-self-center" md="4">
                      <span class="pr-1">คือ</span>
                      <span class="pr-1 pl-3">{{
                        estimateCostTotal | numeral('0,0.00')
                      }}</span>
                      <span>บาท</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider />

              <v-card elevation="1" class="mt-5">
              <v-alert v-if="expressInsuranceUnavailable" type="warning" dense outlined data-testid="express-insurance-unavailable">
                ไม่พบสินค้า พ.ร.บ. {{ expressInsuranceUnavailable.sku_code }} ที่เปิดใช้งานสำหรับสาขาและบริษัทประกันนี้ กรุณาตรวจสอบการตั้งค่า ไม่มีการใช้รหัสอื่นแทนอัตโนมัติ
              </v-alert>
              <v-simple-table class="document-product-table">
                  <template v-slot:default>
                    <thead class="light">
                      <tr>
                        <th class="text-center text-h6" style="width: 20%">
                          หมวดหมู่
                        </th>
                        <th class="text-center text-h6" style="width: 20%">
                          สินค้า
                        </th>
                        <th class="text-center text-h6" style="width: 130px">
                          วันเริ่มต้น
                        </th>
                        <th class="text-center text-h6" style="width: 100px">
                          เต็มปี
                        </th>
                        <th class="text-center text-h6" style="width: 150px">
                          วันสิ้นสุด
                        </th>
                        <th class="text-center text-h6">ราคา</th>
                        <th class="text-center text-h6" style="width: 100px">
                          ส่วนลด
                        </th>
                        <th class="text-center text-h6" style="width: 120px">
                          ราคารวม
                        </th>
                        <th class="text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="py-2">
                          <v-row>
                            <v-autocomplete
                              return-object
                              outlined
                              dense
                              label="เลือก พ.ร.บ."
                              data-testid="third-insurance-category"
                              :key="thirdInsuranceCategoryKey"
                              autocomplete="off"
                              :value="form.product[0].sub_category_id"
                              v-bind:items="
                                list_insurance.third_insurance_sub_category
                              "
                              item-text="name"
                              item-value="sub_category_id"
                              @change="handleThirdInsuranceSubCategoryChange"
                              solo
                              filled
                              auto-select-first
                              hide-details
                              :disabled="isUpdate"
                            ></v-autocomplete>
                          </v-row>
                          <v-row>
                            <span
                              class="ml-3"
                              style="color: red"
                              v-if="
                                form.product[0].sub_category_id == '' &&
                                form.product[0].price != 0
                              "
                              >กรุณากรอกข้อมูล</span
                            >
                          </v-row>
                        </td>
                        <td class="px-1 py-3">
                          <v-autocomplete
                            return-object
                            outlined
                            dense
                            label="รหัส"
                            autocomplete="off"
                            :items="sortedManualInsuranceProducts"
                            :item-text="manualInsuranceLabel"
                            data-testid="third-insurance-product"
                            @change="selectManualInsurance"
                            item-value="product_id"
                            solo
                            filled
                            hide-details
                            :disabled="
                              isUpdate || !form.product[0].sub_category_id
                            "
                            :value="form.product[0].product_id"
                            :key="manualInsurancePickerKey"
                          >
                            <template slot="item" slot-scope="{ item }">
                              {{ manualInsuranceLabel(item) }}</template
                            >
                          </v-autocomplete>
                        </td>
                        <td class="px-1">
                          <DatePicker
                            label="วันเริ่มต้น"
                            :value="form.product[0].start_date"
                            @onChange="
                              (val) => (
                                changeIsFullYearByStartDate(
                                  val,
                                  is_full_year,
                                  0
                                ),
                                !is_full_year ? cal_ins_not_full_year() : null
                              )
                            "
                            hideDetails
                            :disabled="isUpdate"
                          />
                        </td>
                        <td class="">
                          <v-checkbox
                            class="mt-1 ml-5"
                            dense
                            v-model="is_full_year"
                            hide-details
                            @change="(val) => changeIsFullYear(val, 0)"
                            :disabled="isUpdate"
                          />
                        </td>
                        <td class="px-1">
                          <DatePicker
                            label="วันสิ้นสุด"
                            :value="form.product[0].end_date"
                            @onChange="
                              (val) => (
                                (form.product[0].end_date = val),
                                cal_ins_not_full_year(),
                                (is_full_year = false)
                              )
                            "
                            hideDetails
                            :disabled="isUpdate || is_full_year"
                          />
                        </td>
                        <td class="px-1">
                          <v-text-field
                            class="my-1"
                            outlined
                            dense
                            :value="
                              form.product[0].product_price | numeral('0,0.00')
                            "
                            hide-details
                            :disabled="
                              isUpdate || !form.product[0].sub_category_id
                            "
                            @change="
                              (value) =>
                                handleProductPrice(0, 'product_price', value)
                            "
                            @focus="$event.target.select()"
                          />
                        </td>
                        <td class="px-1">
                          <v-text-field
                            class="my-1"
                            outlined
                            dense
                            :value="
                              form.product[0].discount | numeral('0,0.00')
                            "
                            hide-details
                            :disabled="
                              isUpdate || !form.product[0].sub_category_id
                            "
                            @change="
                              (value) =>
                                handleProductPrice(0, 'discount', value)
                            "
                            @focus="$event.target.select()"
                          />
                        </td>
                        <td class="px-1">
                          <v-text-field
                            class="my-1"
                            outlined
                            dense
                            :value="form.product[0].price | numeral('0,0.00')"
                            hide-details
                            disabled
                          />
                        </td>
                        <td class="text-center px1">
                          <v-btn
                            class="my-1"
                            color="error"
                            fab
                            tile
                            small
                            elevation="0"
                            @click="deleteProduct(0)"
                            :disabled="isUpdate"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>

                      <tr>
                        <td class="py-2">
                          <v-row>
                            <v-autocomplete
                              return-object
                              outlined
                              dense
                              label="เลือก ประกันภัย"
                              autocomplete="off"
                              v-bind:items="
                                list_insurance.insurance_sub_category
                              "
                              item-text="name"
                              @change="
                                (val) => {
                                  getInsuranceProduct(val.sub_category_id);
                                }
                              "
                              solo
                              filled
                              auto-select-first
                              hide-details
                              :disabled="isUpdate"
                              v-model="form.product[1].sub_category_id"
                              item-value="sub_category_id"
                            ></v-autocomplete
                          ></v-row>
                          <v-row>
                            <span
                              class="ml-3"
                              style="color: red"
                              v-if="hasIncompleteInsuranceProduct()"
                              >กรุณากรอกข้อมูล</span
                            >
                          </v-row>
                        </td>
                        <td class="px-1 py-3">
                          <v-autocomplete
                            return-object
                            outlined
                            dense
                            label="รหัส"
                            autocomplete="off"
                            v-bind:items="list_insurance.insurance_product"
                            :item-text="(item) => item.sku_code"
                            solo
                            filled
                            auto-select-first
                            hide-details
                            :disabled="
                              isUpdate || !form.product[1].sub_category_id
                            "
                            @change="setInsuranceForm"
                            item-value="product_id"
                            v-model="form.product[1].product_id"
                          >
                            <template slot="item" slot-scope="{ item }">
                              {{ item.sku_code }}</template
                            >
                          </v-autocomplete>
                        </td>
                        <td class="px-1">
                          <DatePicker
                            label="วันเริ่มต้น"
                            :value="form.product[1].start_date"
                            @onChange="
                              (val) =>
                                changeIsFullYearByStartDate(
                                  val,
                                  is_insurance_full_year,
                                  1
                                )
                            "
                            hideDetails
                            :disabled="isUpdate"
                          />
                        </td>
                        <td>
                          <v-checkbox
                            class="mt-1 ml-5"
                            dense
                            v-model="is_insurance_full_year"
                            hide-details
                            @change="(val) => changeIsFullYear(val, 1)"
                            :disabled="isUpdate"
                          />
                        </td>
                        <td class="px-1">
                          <DatePicker
                            label="วันสิ้นสุด"
                            :value="form.product[1].end_date"
                            @onChange="
                              (val) => (form.product[1].end_date = val)
                            "
                            hideDetails
                            :disabled="isUpdate || is_insurance_full_year"
                          />
                        </td>
                        <td class="px-1">
                          <v-text-field
                            class="my-1"
                            outlined
                            dense
                            :value="
                              form.product[1].product_price | numeral('0,0.00')
                            "
                            hide-details
                            :disabled="
                              isUpdate || !form.product[1].sub_category_id
                            "
                            @change="
                              (value) =>
                                handleProductPrice(1, 'product_price', value)
                            "
                            @focus="$event.target.select()"
                          />
                        </td>
                        <td class="px-1">
                          <v-text-field
                            class="my-1"
                            outlined
                            dense
                            :value="
                              form.product[1].discount | numeral('0,0.00')
                            "
                            hide-details
                            :disabled="
                              isUpdate || !form.product[1].sub_category_id
                            "
                            @change="
                              (value) =>
                                handleProductPrice(1, 'discount', value)
                            "
                            @focus="$event.target.select()"
                          />
                        </td>
                        <td class="px-1">
                          <v-text-field
                            class="my-1"
                            outlined
                            dense
                            :value="form.product[1].price | numeral('0,0.00')"
                            hide-details
                            disabled
                          />
                        </td>
                        <td class="text-center px-1">
                          <v-btn
                            color="error"
                            class="my-1"
                            fab
                            tile
                            small
                            elevation="0"
                            @click="deleteProduct(1)"
                            :disabled="isUpdate"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-alert
                  v-if="requiresManualTax"
                  data-testid="manual-tax-notice"
                  type="warning"
                  outlined
                  dense
                  class="mt-4"
                >
                  ประเภทรถนี้ต้องกรอกค่าภาษีด้วยตนเอง ระบบไม่ได้คำนวณภาษีอัตโนมัติ
                  และไม่ได้หมายความว่าภาษีเป็นศูนย์ โปรดตรวจสอบและกรอกยอดในรายการสินค้า
                </v-alert>
                <v-alert
                  v-if="showTaxInfoNotice && !requiresManualTax"
                  type="info"
                  outlined
                  dense
                  class="mt-12 mb-n10"
                >
                  ค่าภาษี {{ total_tax | numeral('0,0.[00]') }} บาท
                  <span class="mx-2">•</span>
                  ค่าปรับ {{ tax_penalty | numeral('0,0.[00]') }} บาท
                  <template v-if="taxRenewalYearCount && taxRenewalEndYear">
                    <span class="mx-2">•</span>
                    ชำระภาษี {{ taxRenewalYearCount }} ปี
                    <span class="mx-2">•</span>
                    ป้ายภาษีใหม่หมดอายุปี
                    {{ taxRenewalEndYear }}
                  </template>
                </v-alert>

                <v-card elevation="0" class="mt-12">
                  <v-simple-table class="document-product-table" v-if="!isLoadingProduct">
                    <template v-slot:default>
                      <thead class="light">
                        <tr>
                          <th class="text-center text-h6" style="width: 10px">
                            #
                          </th>
                          <th class="text-center text-h6" style="width: 28%">
                            ชื่อสินค้า
                          </th>
                          <th class="text-center text-h6" style="width: 28%">
                            รายละเอียด
                          </th>
                          <th class="text-center text-h6" style="width: 110px">
                            ราคา
                          </th>
                          <th class="text-center text-h6" style="width: 80px">
                            ส่วนลด
                          </th>
                          <th
                            class="text-center text-h6"
                            style="width: 30px"
                            v-if="
                              list.setting.vat_registration || vat_price > 0
                            "
                          >
                            Vat %
                          </th>
                          <th class="text-center text-h6">ราคารวม</th>
                          <th class="text-center" style="width: 40px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in form.product.slice(2)"
                          :key="index"
                        >
                          <td class="text-center px-1 my-3 table-style">
                            {{ index + 1 }}.
                          </td>
                          <td class="px-1 table-style">
                            <v-autocomplete
                              :value="item"
                              v-bind:items="list.product"
                              return-object
                              item-text="name"
                              outlined
                              dense
                              solo
                              filled
                              autocomplete="off"
                              @change="(val) => changeProduct(val, index + 2)"
                              auto-select-first
                              hide-details
                              :disabled="isUpdate"
                              class="my-3"
                            >
                            </v-autocomplete>
                          </td>
                          <td class="px-1 table-style">
                            <v-textarea
                              class="my-3"
                              rows="1"
                              outlined
                              dense
                              v-model="item.detail"
                              :disabled="isUpdate"
                              :hide-details="true"
                            />
                          </td>
                          <td class="px-1 table-style">
                            <v-text-field
                              class="my-3"
                              outlined
                              dense
                              :value="item.product_price | numeral('0,0.00')"
                              :disabled="isUpdate"
                              @change="
                                (value) =>
                                  handleProductPrice(
                                    index + 2,
                                    'product_price',
                                    value
                                  )
                              "
                              @focus="$event.target.select()"
                              :hide-details="true"
                            />
                          </td>
                          <td class="px-1 table-style">
                            <v-text-field
                              class="my-3"
                              outlined
                              dense
                              :value="item.discount | numeral('0,0.00')"
                              :disabled="isUpdate"
                              @change="
                                (value) =>
                                  handleProductPrice(
                                    index + 2,
                                    'discount',
                                    value
                                  )
                              "
                              @focus="$event.target.select()"
                              :hide-details="true"
                            />
                          </td>
                          <td
                            class="px-1 table-style"
                            v-if="
                              list.setting.vat_registration || vat_price > 0
                            "
                          >
                            <v-select
                              class="ma-0 my-3"
                              outlined
                              dense
                              background-color="white"
                              :items="list.vat_dict"
                              v-model="item.vat"
                              item-value="value"
                              item-text="name"
                              hide-details
                              :disabled="isUpdate"
                              @change="
                                (value) =>
                                  handleProductPrice(index + 2, 'vat', value)
                              "
                            ></v-select>
                          </td>
                          <td class="px-1 table-style">
                            <v-text-field
                              class="my-3"
                              outlined
                              dense
                              :value="item.price | numeral('0,0.00')"
                              disabled
                              :hide-details="true"
                            />
                          </td>
                          <td
                            class="text-center px-1 pt-3 pb-0 btn-table-style"
                          >
                            <v-btn
                              color="error"
                              fab
                              tile
                              small
                              elevation="0"
                              @click="deleteProduct(index + 2)"
                              :disabled="isUpdate"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-card-text class="pt-4">
                    <v-row justify="space-between">
                      <v-col cols="12" md="4">
                        <v-btn
                          color="primary"
                          outlined
                          @click="addProduct"
                          :disabled="isUpdate"
                        >
                          + เพิ่มสินค้า
                        </v-btn>
                        <v-textarea
                          name="note"
                          v-model="form.note"
                          class="mt-10"
                          label="หมายเหตุท้ายใบเสนอราคา"
                          outlined
                          dense
                        />
                      </v-col>
                      <v-col cols="12" md="5" lg="4" xl="3" class="pr-7 fz-3">
                        <div class="mb-3">
                          <span>รวมเป็นเงิน</span>
                          <span class="float-right">
                            {{ total_price | numeral('0,0.00') }}
                          </span>
                        </div>
                        <div class="mb-3">
                          <span>ส่วนลดรวม</span>
                          <span class="float-right">
                            {{ total_discount | numeral('0,0.00') }}
                          </span>
                        </div>
                        <div class="mb-3">
                          <span>ราคาหลังหักส่วนลด</span>
                          <span class="float-right">
                            {{
                              (total_price - total_discount) | numeral('0,0.00')
                            }}
                          </span>
                        </div>
                        <div
                          class="mb-3"
                          v-if="list.setting.vat_registration || vat_price > 0"
                        >
                          <span>ภาษีมูลค่าเพิ่ม 7%</span>
                          <span class="float-right">
                            {{ vat_price | numeral('0,0.00') }}
                          </span>
                        </div>
                        <div class="mb-3">
                          <span>จำนวนเงินรวมทั้งสิ้น</span>
                          <span class="float-right">
                            {{ net_price | numeral('0,0.00') }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col class="text-left" v-if="this.form._id && this.form.status == 1" cols="12" md>
          <v-btn class="ml-5" small color="red" outlined @click="followup()">
            เพิ่มติดตามงาน อีกครั้ง
          </v-btn>
        </v-col>
        <v-col class="text-right" cols="12" md>
          <v-btn class="ml-5" small color="grey" outlined @click="close()">
            ปิดหน้าต่าง
          </v-btn>
          <v-btn
            class="ml-5"
            color="primary white--text"
            small
            @click="save()"
            :disabled="loading || !formHydrationReady"
            :loading="loading"
          >
            บันทึกข้อมูล
          </v-btn>

          <PrintDocument
            :key="printKey"
            v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 0"
            :docTypeId="docTypeId"
            :type="docType"
            :data="dataPrint.main_bill"
            :data2="dataPrint.split_bill"
            ref="printDocument"
            :disabled="!form.number"
          >
            <v-btn
              class="ml-5"
              small
              color="primary"
              outlined
              :disabled="!form.number"
              :loading="loading"
            >
              พิมพ์ <v-icon right>mdi-printer</v-icon>
            </v-btn>
          </PrintDocument>

          <PrintDocument9inc
            :key="printKey"
            v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 2"
            :docTypeId="docTypeId"
            :type="docType"
            :data="dataPrint.main_bill"
            :data2="dataPrint.split_bill"
            ref="printDocument"
            :disabled="!form.number"
          >
            <v-btn
              class="ml-5"
              small
              color="primary"
              outlined
              :disabled="!form.number"
              :loading="loading"
            >
              พิมพ์ <v-icon right>mdi-printer</v-icon>
            </v-btn>
          </PrintDocument9inc>
          <PrintDocument80mm
            :key="printKey"
            v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 1"
            :docTypeId="docTypeId"
            :type="docType"
            :data="dataPrint.main_bill"
            :data2="dataPrint.split_bill"
            ref="printDocument"
            :disabled="!form.number"
          >
            <v-btn
              class="ml-5"
              small
              color="primary"
              outlined
              :disabled="!form.number"
              :loading="loading"
            >
              พิมพ์ <v-icon right>mdi-printer</v-icon>
            </v-btn>
          </PrintDocument80mm>

          <PrintDocumentFull
            :key="printKey"
            v-if="formHydrationReady && dataPrint.main_bill && form.number && list.setting.receipt_printing_format == 3"
            :docTypeId="docTypeId"
            :type="docType"
            :data="dataPrint.main_bill"
            :data2="dataPrint.split_bill"
            ref="printDocument"
            :disabled="!form.number"
          >
            <v-btn
              class="ml-5"
              small
              color="primary"
              outlined
              :disabled="!form.number"
              :loading="loading"
            >
              พิมพ์ <v-icon right>mdi-printer</v-icon>
            </v-btn>
          </PrintDocumentFull>

          <v-btn
            class="ml-5"
            small
            color="error"
            outlined
            @click="overdue()"
            :disabled="
              form.status != 0 || !isEdit || !$route.params.id || loading
            "
            :loading="loading"
          >
            ค้างชำระ
          </v-btn>
          <v-btn
            class="ml-5"
            small
            color="error"
            @click="pay()"
            :disabled="
              form.status != 0 || !isEdit || !$route.params.id || loading
            "
            :loading="loading"
          >
            ชำระเงิน
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog content-class="document-dialog"
        persistent
        scrollable
        max-width="800"
        v-model="dialogYearChoose"
      >
        <YearChoose
          :item="dialogYearChooseData"
          @onClose="dialogYearChoose = false"
          @onSubmit="onSubmitYear"
        />
      </v-dialog>
      <v-dialog content-class="document-dialog" persistent scrollable max-width="1200" v-model="dialogAddress">
        <AddressDetail
          :item="dialogAddressData"
          @onClose="dialogAddress = false"
          @onSubmit="onSubmitAddress"
        />
      </v-dialog>

      <v-dialog content-class="document-dialog" persistent scrollable max-width="1200" v-model="dialogEditCar">
        <DocumentEditCar
          :item="dialogEditDocumentData"
          :provinces="list.provinces"
          @onClose="dialogEditCar = false"
          @onSubmit="onSubmitEditDocument"
        />
      </v-dialog>

      <v-dialog content-class="document-dialog"
        persistent
        scrollable
        max-width="1200"
        v-model="dialogEditCustomer"
      >
        <DocumentEditCustomer dialog-content-class="document-dialog"
          :item="dialogEditDocumentData"
          :discountedGroups="list.discounted_groups"
          @onClose="dialogEditCustomer = false"
          @onSubmit="onSubmitEditDocument"
        />
      </v-dialog>

      <v-dialog content-class="document-dialog" persistent scrollable max-width="800" v-model="dialogPayChoose">
        <PayChoose @onClose="handleClosePay" :id="form._id" />
      </v-dialog>

      <div v-if="dialogSuccess">
        <v-dialog content-class="document-dialog" persistent scrollable max-width="600" v-model="dialogSuccess">
          <PaySuccess
            :item_id="document_id"
            :id="form._id"
            @onClose="(dialogSuccess = false), $emit('onClose'), close()"
          ></PaySuccess>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import permissionConsumer from '@/mixins/permissionConsumer';
import PrintDocument from '@/components/PrintDocument/printDocument.vue';
import PrintDocument9inc from '@/components/PrintDocument/printDocument9inc.vue';
import PrintDocument80mm from '@/components/PrintDocument/printDocument80mm.vue';
import PrintDocumentFull from '@/components/PrintDocument/printDocumentFull.vue';
import AddressDetail from '@/components/Address/AddressDetail.vue';
import DocumentEditCar from '@/components/DocumentEditCar.vue';
import DocumentEditCustomer from '@/components/DocumentEditCustomer.vue';
import DatePicker from '@/components/DatePicker.vue';
import DatePicker2 from '@/components/DatePicker2.vue';
import PickupTimePicker from '@/components/PickupTimePicker.vue';
import documentPickupSchedule from '@/mixins/documentPickupSchedule';
import customerDisplayDocument from '@/legacy/customerDisplay/documentMixin';
import carTaxCalculation from '@/legacy/carTax/carTaxMixin';
const carTypeLoader = require('@/mixins/carTypeLoader');
const {
  isSkuMismatchForCarType,
  isSkuAutoSelectableForCarType,
} = require('@/utils/carTypeInsuranceSku');
const {
  getElectricVehicleWeightError,
} = require('@/utils/electricVehicleWeight');
import CustomerDisplayButton from '@/legacy/customerDisplay/CustomerDisplayButton.vue';
import {
  createLatestRequestGuard,
  createDocumentLoadTrace,
  isAutomaticPrintRequest,
  loadSavedDocumentPhase,
  runDeferredDocumentTasks,
  runRequiredDocumentTasks
} from '@shared/document-loading';
import PayChoose from './PayChoose.vue';
import PaySuccess from './PaySuccess';
import YearChoose from './YearChoose';
import { required, numeric, minValue } from 'vuelidate/lib/validators';
import * as moment from 'moment';

// Mirrors the motorcycle/car buckets document.py's get_express_product() actually handles.
// Any other car_type falls into its 'else: pass' branch there with no safe product
// defaults, so the UI must not request an express catalog for it.
const EXPRESS_PRODUCT_CAR_TYPES = [
  'CT12', 'CT13', 'CT17', 'CT15',
  'CT1', 'CT2', 'CT3', 'CT110', 'CT130', 'CT140', 'CT170', 'CT180', 'CT11', 'CT900',
];

const manualInsuranceRecommendation = require('@/mixins/manualInsuranceRecommendation');

export default {
  mixins: [permissionConsumer, manualInsuranceRecommendation, documentPickupSchedule, customerDisplayDocument, carTaxCalculation, carTypeLoader],
  components: {
    CustomerDisplayButton,
    PaySuccess,
    PrintDocument,
    PrintDocument9inc,
    PrintDocument80mm,
    PrintDocumentFull,
    AddressDetail,
    DocumentEditCar,
    DocumentEditCustomer,
    DatePicker,
    DatePicker2,
    PickupTimePicker,
    PayChoose,
    YearChoose,
  },
  props: {
    id: {
      required: false,
      type: String,
      default: '',
    },
  },
  validations: {
    form: {
      product: { sub_category_id: { required } },
    },
  },
  data: () => ({
    carSearching: false,
    carInfoTimeout: null,
    lastCarInfoKey: '',
    pendingCarInfoKey: '',
    carInfoRequestSeq: 0,
    expressProductRefreshTimeout: null,
    vehiclePriceChangeNotice: false,
    vehiclePriceChangeNoticeTimeout: null,
    pendingExpressProductKey: '',
    expressProductLoadedKey: '',
    expressProductRequestSeq: 0,
    expressProductRefreshSuppressions: 0,
    documentProductWriteVersion: 0,
    documentHydrationDepth: 0,
    vehicleProductReapplySeq: 0,
    thirdInsuranceProductRequestSeq: 0,
    thirdInsuranceSelectionSeq: 0,
    thirdInsuranceCategoryKey: 0,
    quickProductRoles: {
      third_insurand: false,
    },
    activeCarSpecificationField: '',
    selectStart: -1,
    dialogPayChoose: false,
    current_date: moment().format('YYYY-MM-DDTHH:mm:ss'),
    max_taxout_date: moment().add(2, 'years').format('YYYY-MM-DDTHH:mm:ss'),
    isUrgent: false,
    detailCar: false,
    detailCustomer: false,
    customer_name_search: '',
    customerSource: 'manual-entry',
    customerSelectedName: '',
    customerRequestSeq: 0,
    customerSearchTimeout: null,
    customerSearchRequestSeq: 0,
    customerSearchCancelSource: null,
    isSyncingCustomerSearch: false,
    docTypeId: 0,
    docType: 'ใบเสนอราคา',
    docPath: 'quotation',
    dataPrint: {
      main_bill: null,
      split_bill: null,
    },
    formHydrationReady: false,
    formHydrationFailed: false,
    printRequestGuard: createLatestRequestGuard(),
    dialogYearChoose: false,
    dialogYearChooseData: '',
    dialogSuccess: false,
    document_id: '',
    dialogAddressKey: '',
    dialogAddress: false,
    dialogAddressData: {
      address: '',
      district: '',
      postal_code: '',
      province: '',
      sub_district: '',
    },
    dialogEditCar: false,
    allowElectricVehicleWeightCorrection: false,
    dialogEditCustomer: false,
    dialogEditDocumentData: {
      document_id: '',
      car_plate: '',
      car_province: '',
      customer_address: {
        address: '',
        district: '',
        postal_code: '',
        province: '',
        sub_district: '',
      },
      customer_is_delivery_address: false,
      customer_delivery_address: {
        address: '',
        district: '',
        postal_code: '',
        province: '',
        sub_district: '',
      },
      customer_phone_number: '',
      customer_taxpayer_number: '',
      customer_company_branch: '',
      discounted_groups_id: '',
      call_alert: false,
      call_remind_renewal: false,
    },
    menu: {
      due_date: false,
    },
    is_full_year: false,
    is_insurance_full_year: false,
    form: {
      approval_id: '',
      approval: '',
      number: '',
      status: 0,
      customer_id: '',
      customer_name: '',
      customer_phone_number: '',
      customer_address: {
        address: '',
        district: '',
        sub_district: '',
        province: '',
        postal_code: '',
      },
      customer_taxpayer_number: '',
      customer_company_branch: '',
      is_delivery_address: false,
      customer_delivery_address: {
        address: '',
        district: '',
        sub_district: '',
        province: '',
        postal_code: '',
      },
      customer_group: '',
      call_alert: false,
      call_remind_renewal: false,
      customer_note: '',
      car_plate_character: '',
      car_plate_number: '',
      car_plate_province: '',
      car_type: 'CT1',
      registration_date: '',
      tax_filling_date: moment()
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DDTHH:mm:ss'),
      is_corporation_car: false,
      car_registration_url: '',
      extra_fuel: 0,
      car_fuel: 0,
      car_weight: '',
      engine_size: '',
      is_original_document: false,
      taxout_date: '',
      bill_taxout_date: '',
      branch_id: '',
      document_type: 0,
      customer_branch_office: '',
      date_of_issue: '',
      due_date: '',
      project_name: '',
      pick_up_date: '',
      pick_up_time: '',
      show_pickup: true,
      tax_year_init: '',
      tax_year_ended: '',
      tax_renewal_end_year: 0,
      tax_renewal_year_count: 0,
      product: [
        {
          category_id: 'PC1',
          discount: 0,
          broker: '',
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sku_code: '',
          sku_detail: '',
          sub_category_id: '',
          sub_category_name: '',
          vat: 0,
          vat_price: 0,
          insurance_premium: 0,
          start_date: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          end_date: moment()
            .add(1, 'years')
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          product_price: 0,
        },
        {
          category_id: 'PC2',
          discount: 0,
          broker: '',
          name: '',
          sku_code: '',
          sku_detail: '',
          price: 0,
          product_id: '',
          product_type: '',
          sub_category_id: '',
          sub_category_name: '',
          type: 0,
          vat: 0,
          vat_price: 0,
          insurance_premium: 0,
          start_date: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          end_date: moment()
            .add(1, 'years')
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          product_price: 0,
        },
        {
          category_id: '',
          discount: 0,
          message_on_select: '',
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sub_category_id: '',
          sub_category_name: '',
          vat: 0,
          vat_price: 0,
          product_price: 0,
        },
      ],
      original_document_price: 0,
      total_price: 0,
      total_discount: 0,
      net_price: 0,
      notation: '',
      note: '',
      discounted_groups_id: '',
    },
    thisBranch: {},
    list: {
      approval: [],
      provinces: [
        'กระบี่',
        'กรุงเทพมหานคร',
        'กาญจนบุรี',
        'กาฬสินธุ์',
        'กำแพงเพชร',
        'ขอนแก่น',
        'จันทบุรี',
        'ฉะเชิงเทรา',
        'ชลบุรี',
        'ชัยนาท',
        'ชัยภูมิ',
        'ชุมพร',
        'เชียงราย',
        'เชียงใหม่',
        'ตรัง',
        'ตราด',
        'ตาก',
        'นครนายก',
        'นครปฐม',
        'นครพนม',
        'นครราชสีมา',
        'นครศรีธรรมราช',
        'นครสวรรค์',
        'นนทบุรี',
        'นราธิวาส',
        'น่าน',
        'เบตง',
        'บึงกาฬ',
        'บุรีรัมย์',
        'ปทุมธานี',
        'ประจวบคีรีขันธ์',
        'ปราจีนบุรี',
        'ปัตตานี',
        'พระนครศรีอยุธยา',
        'พะเยา',
        'พังงา',
        'พัทลุง',
        'พิจิตร',
        'พิษณุโลก',
        'เพชรบุรี',
        'เพชรบูรณ์',
        'แพร่',
        'ภูเก็ต',
        'มหาสารคาม',
        'มุกดาหาร',
        'แม่ฮ่องสอน',
        'ยโสธร',
        'ยะลา',
        'ร้อยเอ็ด',
        'ระนอง',
        'ระยอง',
        'ราชบุรี',
        'ลพบุรี',
        'ลำปาง',
        'ลำพูน',
        'เลย',
        'ศรีสะเกษ',
        'สกลนคร',
        'สงขลา',
        'สตูล',
        'สมุทรปราการ',
        'สมุทรสงคราม',
        'สมุทรสาคร',
        'สระแก้ว',
        'สระบุรี',
        'สิงห์บุรี',
        'สุโขทัย',
        'สุพรรณบุรี',
        'สุราษฎร์ธานี',
        'สุรินทร์',
        'หนองคาย',
        'หนองบัวลำภู',
        'อ่างทอง',
        'อำนาจเจริญ',
        'อุดรธานี',
        'อุตรดิตถ์',
        'อุทัยธานี',
        'อุบลราชธานี',
      ],
      product: [],
      // Populated from the store (centralized in backend/car_types.json) in created().
      car_type_dict: [],
      vat_dict: [
        { value: 0, name: '0%' },
        { value: 1, name: '7%' },
      ],
      setting: null,
      discounted_groups: [],
      cars: [],
      filter_customers: [],
      expressProduct: {
        inspect_product: null,
        tax_product: null,
        third_insurand_product: null,
        extension_tax_fee_product: null,
        motorcycle_3rdinsurance: null,
        urgent_extension_tax_fee_product: null,
      },
    },
    loading: true,
    approvals: null,
    car: { third_insurance_company: '', insurance_company: '' },
    temp_car: {
      _id: '',
      plate_character: '',
      plate_number: '',
      plate_province: '',
    },
    plateNumberTouched: false,
    customer: {
      _id: '',
      name: '',
    },
    temp_customer: {
      _id: '',
      name: '',
    },

    isEdit: true,
    product_all: false,
    product_selected: [],
    isEditFilterExpressProduct: false,
    isUpdate: false,
    car_tax: {
      net_tax_price: 0,
      total_tax_price: [0, 0, 0, 0],
      tax_price: [0, 0, 0, 0, 0, 0],
      tax_by_year: [0, 0, 0, 0],
      popup_massage: ['', '', '', '', '', ''],
      late_age: 0,
      car_age: 0,
      tax_year_init: moment()
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DDTHH:mm:ss'),
      tax_year_ended: null,
    },
    isActiveTaxYearInit: false,
    isActiveTaxYearEnd: false,
    tax_penalty: 0,
    total_tax: 0,
    isLoadingProduct: false,
    valid: false,
    errors: {},
    checkThirdInsurance: '',
    showPhoneNumber: false,
    toggleShowPhoneNumber: false,
    editMode: null,
    deleteOnce: false,
    printKey: 1,
    documentLoadRequestSeq: 0,
    documentLoadGeneration: 0,
    updatingCustomerTaxIdVisibility: false,
    list_insurance: {
      insurance_sub_category: [],
      third_insurance_sub_category: [],
      third_insurance_product: [],
      insurance_product: [],
    },
    third_insurance_sub_category_id: null,
    insurance_sub_category_id: null,
    estimateCost: 0,
    estimateCostTotal: 0,
    permission: {},
    transTimeout: null,
  }),
  validations: {
    form: {
      car_plate_character: { required },
      car_plate_number: { required, numeric, minValue: minValue(0) },
      car_plate_province: { required },
      car_type: { required },
      customer_name: { required },
    },
  },

  async created() {
    const loadGeneration = ++this.documentLoadGeneration;
    this.loading = true;
    try {
      for (let i = 0; i < 5; i++) {
        if (this.$store.state.profile.name) {
          if (!this.isDocumentLoadCurrent(loadGeneration)) return;
          await this.initializeData(loadGeneration);
          return; // Exit the function once the profile is found and initialized
        }
          await this.sleep(500);
      }
        //await this.$store.dispatch('onReload');
        await this.sleep(500);
        await this.$store.dispatch('getBranchs');
        await this.$store.dispatch('getMyProfile');
        await this.$store.dispatch('getGroupPermissions');
        if (!this.isDocumentLoadCurrent(loadGeneration)) return;
        await this.initializeData(loadGeneration);
    } catch (error) {
      if (!this.isDocumentLoadCurrent(loadGeneration)) return;
      this.formHydrationFailed = true;
      console.error('Unable to initialize quotation detail:', error);
      this.$alertServerError({
        title:
          (error && error.userMessage) || 'ไม่สามารถโหลดข้อมูลใบเสนอราคาได้',
      });
    } finally {
      if (this.isDocumentLoadCurrent(loadGeneration)) this.loading = false;
    }
  },
  beforeDestroy() {
    if (this.approvalCancelSource) this.approvalCancelSource.cancel('Document closed');
    this.approvalCancelSource = null;
    this.documentLoadGeneration += 1;
    this.documentLoadRequestSeq += 1;
    this.customerRequestSeq += 1;
    this.printRequestGuard.invalidate();
    this.invalidatePendingQuickProductMutations();
    this.cancelCustomerSearch();
  },

  methods: {
    isDocumentLoadCurrent(generation) {
      return !this._isBeingDestroyed && generation === this.documentLoadGeneration;
    },
    onDateOfIssueChange(date) {
      this.form.date_of_issue = `${date}T${moment().format('HH:mm:ss')}`;
      this.$refs.menu_date_of_issue.save(this.form.date_of_issue);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async initializeData(loadGeneration = ++this.documentLoadGeneration) {
      const isCurrent = () => this.isDocumentLoadCurrent(loadGeneration);
      const routeDocumentId = this.$route.params.id;
      this.form.branch_id = this.$store.state.selected_branch._id;
      this.formHydrationReady = false;
      this.formHydrationFailed = false;
      const loadTrace = createDocumentLoadTrace('quotation');
      this.isUpdate = this.$route.params.id ? true : false;
      this.editMode = this.$route.params.id ? true : false;
      if (!this.editMode) {
        this.toggleShowPhoneNumber = true;
      }
      if (this.isUpdate) {
        await this.getSetting();
        if (!isCurrent()) return;
        loadTrace.mark('core-ready');
        await loadSavedDocumentPhase({
          loadRequired: () => Promise.all([
            this.loadCarTypeDict().then(rows => { this.list.car_type_dict = rows; }),
            this.loadCarTypeInsuranceSku(),
            this.getUserGroup(),
            this.getApproval(),
            this.getProduct(),
            this.getDiscountedGroups({ preserveForm: true }),
          ]),
          loadDocument: requiredLookups => this.getData(routeDocumentId, {
            beforeHydration: requiredLookups,
            deferPrint: true,
            manageLoading: false,
            loadTrace,
          }),
        });
        if (!isCurrent()) return;
        loadTrace.mark('document-ready', 'document-response');
        if (this.form.status == 1 || this.form.status == 2) {
          this.isEdit = false;
        }
        if (this.form.status == 0) {
          this.isUpdate = false;
          this.getApprovalById(this.$store.state.profile._id);
        }
      } else {
        await Promise.all([
        this.getUserGroup(),
        this.loadCarTypeDict().then(rows => { this.list.car_type_dict = rows; }),
        this.loadCarTypeInsuranceSku(),
      ]);
        if (!isCurrent()) return;
        await this.getSetting();
        if (!isCurrent()) return;
        loadTrace.mark('core-ready');
        await this.getApproval();
        if (!isCurrent()) return;
        await this.getProduct();
        if (!isCurrent()) return;
        await this.getDiscountedGroups();
        if (!isCurrent()) return;
        await this.getApprovalById(this.$store.state.profile._id);
        if (!isCurrent()) return;
        await this.getDocumentNote();
        if (!isCurrent()) return;
        this.form.date_of_issue = moment().format('YYYY-MM-DDTHH:mm:ss');
        this.form.due_date = moment()
          .add(30, 'days')
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
      }

      await this.main_calculate();
      if (!isCurrent()) return;
      if (this.editMode) {
        this.loading = false;
        await this.$nextTick();
        if (!isCurrent()) return;
        loadTrace.mark('visible', 'document-ready');
        const hydrationRequestSeq = this.documentLoadRequestSeq;

        const printTask = runDeferredDocumentTasks([
          {
            name: 'print-data',
            run: () => this.getDataPrint(routeDocumentId, { requireCurrentRoute: true }),
          },
        ], (error, task) => {
          this.$captureException(error, { source: `quotation.Detail.${task}` });
        });

        await runRequiredDocumentTasks([
          {
            name: 'express-products',
            run: () => this.form.status == 0
              ? this.getExpressProduct({ throwOnError: true })
              : Promise.resolve(),
          },
          {
            name: 'third-insurance',
            run: () => this.getThirdInsuranceSubCategory({
              preserveForm: true,
              throwOnError: true,
              requestSeq: hydrationRequestSeq,
            }),
          },
          {
            name: 'insurance',
            run: () => this.getInsuranceSubCategory({
              preserveForm: true,
              requestSeq: hydrationRequestSeq,
            }),
          },
        ]);
        if (!isCurrent()) return;
        this.formHydrationReady = true;
        loadTrace.mark('form-ready', 'visible');

        if (isAutomaticPrintRequest(this.$route.query)) {
          await printTask;
          if (!isCurrent()) return;
          await this.$nextTick();
          if (!isCurrent()) return;
          if (this.$refs.printDocument) this.$refs.printDocument.print();
          this.$route.query.print = false;
        } else if (this.$route.query.pay == 'true' || this.$route.query.pay == true) {
          this.dialogPayChoose = true;
        }
        return;
      }

      await this.getThirdInsuranceSubCategory();
      if (!isCurrent()) return;
      await this.getInsuranceSubCategory();
      if (!isCurrent()) return;
      this.formHydrationReady = true;
      
      if (
        this.$route.query.print == 'true' ||
        this.$route.query.download == 'true' ||
        this.$route.query.print == true ||
        this.$route.query.download == true
      ) {
        this.$refs.printDocument.print();
        this.$route.query.print = false;
      } else if (
        this.$route.query.pay == 'true' ||
        this.$route.query.pay == true
      ) {
        this.dialogPayChoose = true;
      }
      this.loading = false;
    },

    async getThirdInsuranceSubCategory(options = {}) {
      let filter = {
        branch_id: this.$store.state.selected_branch._id,
      };
      let body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      const response = await this.$axios.post(
        `${this.$baseUrl}/document/get_third_insurance_sub_category`,
        body
      );
      if (
        typeof options.requestSeq !== 'undefined' &&
        options.requestSeq !== this.documentLoadRequestSeq
      ) return false;
      this.list_insurance.third_insurance_sub_category = response.result;
      if (this.form.product[0] && this.form.product[0].sub_category_id) {
        const currentSubCategory = this.form.product[0].sub_category_id;
        const subCategoryId = typeof currentSubCategory === 'object'
          ? currentSubCategory.sub_category_id
          : currentSubCategory;
        if (!options.preserveForm && typeof currentSubCategory === 'object') {
          this.form.product[0].sub_category_id = subCategoryId;
        }
        await this.getThirdInsuranceProduct(
          subCategoryId,
          0,
          false,
          options.throwOnError
        );
      }
    },
    async getInsuranceSubCategory(options = {}) {
      let filter = {
        branch_id: this.$store.state.selected_branch._id,
      };
      let body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      const response = await this.$axios.post(
        `${this.$baseUrl}/document/get_insurance_sub_category`,
        body
      );
      if (
        typeof options.requestSeq !== 'undefined' &&
        options.requestSeq !== this.documentLoadRequestSeq
      ) return false;
      this.list_insurance.insurance_sub_category = response.result;

      if (this.form.product[1] && this.form.product[1].sub_category_id) {
        await this.getInsuranceProduct(
          this.form.product[1].sub_category_id,
          !options.preserveForm,
          options.requestSeq
        );
      }
    },
    async filterAndSetInsuranceForm(val) {
      let sub_category_id = this.form.product[1].sub_category_id;
      await this.getInsuranceProduct(sub_category_id);
      let product_id = val.product_id;
      let newForm = {};
      let sub_cat_detail = this.list_insurance.insurance_sub_category.filter(
        (sub_cat) => sub_cat.sub_category_id == sub_category_id
      );
      let product_detail = this.list_insurance.insurance_product.filter(
        (product) => product.product_id == product_id
      );
      if (sub_cat_detail.length > 0) {
        newForm = { ...newForm, ...sub_cat_detail[0] };
      }
      if (product_detail.length > 0) {
        newForm = { ...newForm, ...product_detail[0] };
      }
      newForm = { ...this.form.product[1], ...newForm };
      this.changeInsurance(newForm);
    },
    async filterAndSetThirdInsuranceForm(val) {
      if (!this.quickProductRoles.third_insurand) return;

      let sub_category_id = this.form.product[0].sub_category_id;
      await this.getThirdInsuranceProduct(sub_category_id, 0, false);
      let product_id = val.product_id;
      let newForm = {};
      let sub_cat_detail =
        this.list_insurance.third_insurance_sub_category.filter(
          (sub_cat) => sub_cat.sub_category_id == sub_category_id
        );
      let product_detail = this.list_insurance.third_insurance_product.filter(
        (product) => product.product_id == product_id
      );
      if (sub_cat_detail.length > 0) {
        newForm = { ...newForm, ...sub_cat_detail[0] };
      }
      if (product_detail.length > 0) {
        newForm = { ...newForm, ...product_detail[0] };
      }
      newForm = { ...this.form.product[0], ...newForm };
      this.changeThirdInsurance(newForm, { preserveDates: true });
    },
    async setInsuranceForm(val) {
      let sub_category_id = this.form.product[1].sub_category_id;
      let product_id = val.product_id;
      let newForm = {};
      let sub_cat_detail = this.list_insurance.insurance_sub_category.filter(
        (sub_cat) => sub_cat.sub_category_id == sub_category_id
      );
      let product_detail = this.list_insurance.insurance_product.filter(
        (product) => product.product_id == product_id
      );
      if (sub_cat_detail.length > 0) {
        newForm = { ...newForm, ...sub_cat_detail[0] };
      }
      if (product_detail.length > 0) {
        newForm = { ...newForm, ...product_detail[0] };
      }
      newForm = { ...this.form.product[1], ...newForm };
      this.changeInsurance(newForm);
    },
    async setThirdInsuranceForm(val, { isUserSelection = true } = {}) {
      if (!val) return;
      if (isUserSelection) {
        this.thirdInsuranceSelectionSeq++;
        this.thirdInsuranceCategoryKey++;
        this.quickProductRoles.third_insurand = false;
      }

      let sub_category_id = this.form.product[0].sub_category_id;
      let product_id = val.product_id;
      let newForm = {};
      let sub_cat_detail =
        this.list_insurance.third_insurance_sub_category.filter(
          (sub_cat) => sub_cat.sub_category_id == sub_category_id
        );
      let product_detail = this.list_insurance.third_insurance_product.filter(
        (product) => product.product_id == product_id
      );
      if (sub_cat_detail.length > 0) {
        newForm = { ...newForm, ...sub_cat_detail[0] };
      }
      if (product_detail.length > 0) {
        newForm = { ...newForm, ...product_detail[0] };
      }
      newForm = { ...this.form.product[0], ...newForm };
      this.changeThirdInsurance(newForm);
      this.checkThirdInsurance = this.form.product[0].product_id;
    },
    async handleThirdInsuranceSubCategoryChange(val) {
      const sub_category_id =
        typeof val === 'object' ? val && val.sub_category_id : val;
      if (!sub_category_id) return;

      const selectionSeq = ++this.thirdInsuranceSelectionSeq;
      const products = await this.getThirdInsuranceProduct(sub_category_id, 0, false);
      if (selectionSeq !== this.thirdInsuranceSelectionSeq) return;
      if (!products || !products.length) {
        // Reset Vuetify's tentative selection while keeping the saved product.
        this.thirdInsuranceCategoryKey++;
        return;
      }

      this.quickProductRoles.third_insurand = false;
      this.checkThirdInsurance = '';
      this.clearThirdInsuranceDocumentProduct();
      this.form.product[0].sub_category_id = sub_category_id;
      const matchingProduct = products.find(
        (product) => this.isThirdInsuranceAutoSelectable(product)
      );
      if (matchingProduct) {
        await this.setThirdInsuranceForm(matchingProduct, { isUserSelection: false });
      }
    },
    async getThirdInsuranceProduct(
      sub_category_id,
      retryCount = 0,
      autoSelect = true,
      throwOnError = false
    ) {
        if (sub_category_id && typeof sub_category_id === 'object') {
          sub_category_id = sub_category_id.sub_category_id;
        }
        const maxRetries = 3; // Set the maximum number of retries

        if (!sub_category_id || !this.form.car_type || !this.form.discounted_groups_id) {
          if (retryCount < maxRetries) {
            console.log('Required parameters are missing, retrying...');
            await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 1 second before retrying
            return this.getThirdInsuranceProduct(
              sub_category_id,
              retryCount + 1,
              autoSelect,
              throwOnError
            );
          } else {
            console.log('Max retries reached, unable to fetch third insurance product');
            return;
          }
        }

        const requestSeq = ++this.thirdInsuranceProductRequestSeq;
        const selectionSeq = this.thirdInsuranceSelectionSeq;
        const requestContext = {
          sub_category_id,
          selected_sub_category_id: this.form.product[0].sub_category_id,
          car_type: this.form.car_type,
          discounted_groups_id: this.form.discounted_groups_id,
          branch_id: this.form.branch_id,
        };
        let filter = {
          sub_category_id: sub_category_id,
          car_type: this.form.car_type,
          discounted_groups_id: this.form.discounted_groups_id,
          branch_id: this.form.branch_id,
          include_all_car_types: true,
        };
        let body = {
          token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
        };

        try {
          const response = await this.$axios.post(
            `${this.$baseUrl}/document/get_third_insurance_product`,
            body
          );

          if (
            requestSeq !== this.thirdInsuranceProductRequestSeq ||
            selectionSeq !== this.thirdInsuranceSelectionSeq ||
            requestContext.selected_sub_category_id !== this.form.product[0].sub_category_id ||
            requestContext.car_type !== this.form.car_type ||
            requestContext.discounted_groups_id !== this.form.discounted_groups_id ||
            requestContext.branch_id !== this.form.branch_id
          ) {
            return;
          }

          if (
            response.result.length ||
            requestContext.sub_category_id === requestContext.selected_sub_category_id
          ) {
            this.list_insurance.third_insurance_product = response.result;
          }
          const matchingProduct = response.result.find(
            (product) => this.isThirdInsuranceAutoSelectable(product)
          );

          if (matchingProduct) {
            if (
              autoSelect &&
              selectionSeq === this.thirdInsuranceSelectionSeq &&
              !this.checkThirdInsurance &&
              !this.form.product[0].product_id
            ) {
              this.form.product[0].product_id = matchingProduct.product_id;
              await this.setThirdInsuranceForm(
                matchingProduct,
                { isUserSelection: false }
              );
            }
          }
          return response.result;
        } catch (error) {
          this.$captureException(error, { source: 'quotation.Detail.getThirdInsuranceProduct' });
          if (throwOnError) throw error;
        }
      },

      isThirdInsuranceCarTypeMismatch(product) {
        return !!product && isSkuMismatchForCarType(
          this.$store.state.list.car_type_insurance_sku,
          this.$store.state.list.car_type_insurance_sku_loaded,
         this.form.car_type,
          product.sku_code,
          this.form.car_fuel
        );
      },

      isThirdInsuranceAutoSelectable(product) {
        return !!product && isSkuAutoSelectableForCarType(
          this.$store.state.list.car_type_insurance_sku,
          this.$store.state.list.car_type_insurance_sku_loaded,
         this.form.car_type,
          product.sku_code,
          this.form.car_fuel
        );
      },

      thirdInsuranceProductLabel(product) {
        const label = product.sku_code + ' ' + product.sku_detail;
        return this.isThirdInsuranceCarTypeMismatch(product)
          ? label + ' (ไม่ตรงกับประเภทรถที่เลือก)'
          : label;
      },

      showThirdInsuranceCarTypeWarning() {
        this.$alertServerError({
          title: 'แจ้งเตือน',
          icon: 'warning',
          html: 'พ.ร.บ. ที่เลือกไม่ตรงกับประเภทรถ กรุณาตรวจสอบก่อนดำเนินการต่อ',
          showConfirmButton: true,
          timer: false,
        });
      },
    async getInsuranceProduct(
      sub_category_id,
      autoSelect = true,
      documentRequestSeq
    ) {
      if (sub_category_id != '') {
        if (typeof sub_category_id === 'object') {
          sub_category_id = sub_category_id.sub_category_id;
        }
        this.list_insurance.insurance_product = [];
        let filter = {
          sub_category_id: sub_category_id,
          car_type: this.form.car_type,
          discounted_groups_id: this.form.discounted_groups_id,
        };
        let body = {
          token: this.$jwt.sign(filter, this.$privateKey, {
            noTimestamp: true,
          }),
        };
        await this.$axios
          .post(`${this.$baseUrl}/document/get_insurance_product`, body)
          .then(async (res) => {
            if (
              typeof documentRequestSeq !== 'undefined' &&
              documentRequestSeq !== this.documentLoadRequestSeq
            ) return false;
            this.list_insurance.insurance_product = res.result;
            if (autoSelect && res.result.length > 0 && this.form.product[1].product_id == '')
              this.changeInsurance(res.result[0]);
            if (!res.result.length) {
              this.$alertServerError({
                title: 'Error',
                html: 'ไม่มีสินค้าที่เปิดใช้งาน <br/>กรุณาเปิดใช้งานสินค้าประกันภัย',
                showConfirmButton: true,
                timer: false,
              });
            }
          });
      }
    },
    formatDate(date) {
      if (!date) return '';

      let year = parseInt(moment(date).format('YYYY'));
      let m_d = moment(date).format('DD/MM');
      return `${m_d}/${year + 543}`;
    },
    carPlateCharacter(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        this.temp_car.plate_character.length >= 7 &&
        evt.target.selectionEnd - evt.target.selectionStart == 0
      ) {
        evt.preventDefault();
      } else if (
        (charCode > 31 && charCode < 48) ||
        (charCode > 57 && charCode < 126)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    carWeightNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else if (
        this.form.car_weight.length >= 5 &&
        evt.target.selectionEnd - evt.target.selectionStart == 0
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    formatCarSpecification(field) {
      const value = this.form[field];
      if (value === '' || value === null || typeof value === 'undefined') {
        return '';
      }

      if (this.activeCarSpecificationField === field) {
        return String(value);
      }

      return Number(value).toLocaleString('en-US');
    },
    updateCarSpecification(field, value) {
      const maxLength = field === 'car_weight' ? 5 : 4;
      const numericValue = String(value || '')
        .replace(/\D/g, '')
        .slice(0, maxLength);

      this.$set(this.form, field, numericValue);
    },
    focusCarSpecification(field, event) {
      this.activeCarSpecificationField = field;
      this.$nextTick(() => event.target.select());
    },
    blurCarSpecification() {
      this.activeCarSpecificationField = '';
    },
    engineNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else if (
        this.form.engine_size.length >= 4 &&
        evt.target.selectionEnd - evt.target.selectionStart == 0
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    carNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        this.plateNumberTouched = true;
        evt.preventDefault();
      } else if (
        this.temp_car.plate_number.length >= 5 &&
        evt.target.selectionEnd - evt.target.selectionStart == 0
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    taxNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else if (
        this.form.customer_taxpayer_number.length >= 13 &&
        evt.target.selectionEnd - evt.target.selectionStart == 0
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else if (
        this.form.customer_phone_number.length >= 11 &&
        evt.target.selectionEnd - evt.target.selectionStart == 0
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    preventDelete(evt) {
      let arrowKey = [37, 38, 39, 40];
      let selectStart = evt.target.selectionStart;
      let selectEnd = evt.target.selectionEnd;
      if (this.editMode && !this.showPhoneNumber && !this.deleteOnce) {
        this.deleteOnce = true;
        this.form.customer_phone_number = '';
        return;
      }
      if (evt.keyCode === 8 || evt.keyCode === 46) {
        if (evt.target.value[selectStart - 1] == '-') {
          setTimeout(
            function () {
              this.form.customer_phone_number = this.parsePhonePattern(
                evt.target.value.slice(0, selectStart - 2) +
                  evt.target.value.slice(
                    selectStart - 1,
                    evt.target.value.length
                  ),
                true
              );
              evt.target.value = this.parsePhonePattern(
                evt.target.value.slice(0, selectStart - 2) +
                  evt.target.value.slice(
                    selectStart - 1,
                    evt.target.value.length
                  ),
                true
              );
            }.bind(this),
            0
          );
        }
      } else {
        if (evt.target.value.length >= 12 && !arrowKey.includes(evt.keyCode)) {
          evt.preventDefault();
        } else {
          this.selectStart = -1;
        }
      }
    },
    parsePhonePattern(value, returnValue = false) {
      let position = value
        .substr(0, 12)
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,7})/);
      let phoneNumber = '';
      phoneNumber = position[1];

      if (position[1].length >= 3) {
        phoneNumber += '-';
      }

      phoneNumber += position[2];

      if (returnValue) {
        return phoneNumber;
      } else {
        this.form.customer_phone_number = phoneNumber;
        if (this.selectStart > -1) {
          let input = document.getElementById('customer_phone_number');
          let selectionStart = this.selectStart;
          window.setTimeout(function () {
            input.focus();
            input.setSelectionRange(selectionStart, selectionStart);
          }, 0);
        } else if (window.event.target.selectionStart < value.length) {
          let input = document.getElementById('customer_phone_number');
          let selectionStart = window.event.target.selectionStart;
          window.setTimeout(function () {
            input.focus();
            input.setSelectionRange(selectionStart, selectionStart, 'forward');
          }, 0);
        }
      }
    },
    productFormat() {
      let temp = [];
      let hasPC1 = false;
      let hasPC2 = false;
      let notGen = true;
      this.form.product.forEach((item, i) => {
        if (item.category_id == 'PC1') hasPC1 = true;
        if (item.category_id == 'PC2') hasPC2 = true;
      });
      if (!hasPC1) {
        temp.splice(0, 0, {
          broker: '',
          category_id: 'PC1',
          discount: 0,
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sku_code: '',
          sku_detail: '',
          sub_category_id: '',
          sub_category_name: '',
          vat: 0,
          vat_price: 0,
          start_date: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          end_date: moment()
            .add(1, 'years')
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          product_price: 0,
        });
      }
      if (!hasPC2) {
        temp.splice(1, 0, {
          broker: '',
          category_id: 'PC2',
          discount: 0,
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sku_code: '',
          sku_detail: '',
          sub_category_id: '',
          sub_category_name: '',
          type: 0,
          vat: 0,
          vat_price: 0,
          start_date: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          end_date: moment()
            .add(1, 'years')
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          product_price: 0,
        });
      }
      this.product_selected = [];
      this.isUrgent = false;
      this.form.product.forEach((item, i) => {
        if (item.category_id == 'PC1' && hasPC1) {
          temp.splice(0, 0, item);
          this.is_full_year =
            moment(item.start_date)
              .add(1, 'years')
              .set({ hour: 0, minute: 0, second: 0 })
              .format('YYYY-MM-DDTHH:mm:ss') ==
            moment(item.end_date)
              .set({ hour: 0, minute: 0, second: 0 })
              .format('YYYY-MM-DDTHH:mm:ss')
              ? true
              : false;
        } else if (item.category_id == 'PC2' && hasPC2) {
          temp.splice(1, 0, item);
          this.is_insurance_full_year =
            moment(item.start_date)
              .add(1, 'years')
              .set({ hour: 0, minute: 0, second: 0 })
              .format('YYYY-MM-DDTHH:mm:ss') ==
            moment(item.end_date)
              .set({ hour: 0, minute: 0, second: 0 })
              .format('YYYY-MM-DDTHH:mm:ss')
              ? true
              : false;
        } else if (item.category_id != '' && item.name != '') {
          notGen = false;
          temp.push(item);
        }
        const quickProductRole = this.getDocumentQuickProductRole(item);
        if (quickProductRole === 'tax' || quickProductRole === 'extension_tax_fee') {
          if (this.product_selected.indexOf('tax') === -1)
            this.product_selected.push('tax');
        } else if (quickProductRole === 'urgent') {
          this.product_selected.push('urgent');
          this.isUrgent = true;
        } else if (quickProductRole === 'inspect') {
          this.product_selected.push('inspect');
        } else if (quickProductRole === 'motorcycle_3rdinsurance') {
          if (this.product_selected.indexOf('third_insurand') === -1)
            this.product_selected.push('third_insurand');
        }
      });

      // this.product_selected = ["inspect", , "third_insurand"];
      if (notGen) {
        temp.push({
          category_id: '',
          discount: 0,
          message_on_select: '',
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sub_category_id: '',
          sub_category_name: '',
          vat: 0,
          vat_price: 0,
          product_price: 0,
        });
      }

      this.product_all =
        this.product_selected.indexOf('tax') !== -1 &&
        this.product_selected.indexOf('third_insurand') !== -1;

      this.form.product = temp;
    },
    showCustomer() {
      if (this.detailCustomer == true) {
        this.form.customer_name = 'ลูกค้าหน้าร้าน';
      }
    },
    async getData(id = this.$route.params.id, options = {}) {
      const requestSeq = (this.documentLoadRequestSeq || 0) + 1;
      this.documentLoadRequestSeq = requestSeq;
      this.invalidatePendingQuickProductMutations();
      this.documentHydrationDepth++;
      if (options.manageLoading !== false) this.loading = true;
      this.customerRequestSeq++;
      this.cancelCustomerSearch();
      this.customerSearchRequestSeq++;
      let body = {
        token: this.$jwt.sign({ document_id: id }, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      if (options.loadTrace) options.loadTrace.mark('document-request-start');
      try {
        return await this.$axios
          .post(`${this.$baseUrl}/document/get_by_id`, body)
          .then(async (res) => {
          if (options.loadTrace) {
            options.loadTrace.mark('document-response', 'document-request-start');
          }
          if (requestSeq !== this.documentLoadRequestSeq) return false;
          if (
            res.status !== 'success' ||
            !res.result ||
            typeof res.result !== 'object' ||
            Array.isArray(res.result)
          ) {
            const error = new Error(`Unable to load quotation: ${res.status}`);
            error.userMessage =
              res.status === "document_id doesn't exist"
                ? 'ไม่พบข้อมูลใบเสนอราคา'
                : 'ไม่สามารถโหลดข้อมูลใบเสนอราคาได้';
            throw error;
          }
          this.form = {
            ...res.result,
            product: Array.isArray(res.result.product)
              ? res.result.product
              : [],
            temp_product: Array.isArray(res.result.temp_product)
              ? res.result.temp_product
              : [],
            car_plate_province:
              res.result.car_plate_province || res.result.car_province || '',
            extra_fuel:
              res.result.extra_fuel === null ||
              typeof res.result.extra_fuel === 'undefined'
                ? 0
                : res.result.extra_fuel,
            car_fuel:
              res.result.car_fuel === null ||
              typeof res.result.car_fuel === 'undefined'
                ? 0
                : res.result.car_fuel,
            is_corporation_car:
              res.result.is_corporation_car === null ||
              typeof res.result.is_corporation_car === 'undefined'
                ? false
                : res.result.is_corporation_car,
          };
          this.allowElectricVehicleWeightCorrection = Boolean(
            getElectricVehicleWeightError(
              this.form.car_fuel,
              this.form.car_weight
            )
          );
          this.quickProductRoles.third_insurand = false;
          this.customerSource = this.normalizeCustomerSource(
            res.result.customer_source
          );
          this.customerSelectedName = this.form.customer_name || '';
          this.detailCustomer = res.result.detailCustomer === true;
          this.detailCar = res.result.detailCar === true;
          this.checkThirdInsurance = this.form.temp_product[0]
            ? this.form.temp_product[0].product_id
            : '';
          this.form.bill_taxout_date = this.form.taxout_date;
          this.customer = {
            _id: this.form.customer_id,
            name: this.form.customer_name,
          };
          if (this.form.customer_id && this.form.customer_name) {
            const customerIndex = this.list.filter_customers.findIndex(
              (item) => item._id === this.form.customer_id
            );
            const documentCustomer = {
              _id: this.form.customer_id,
              name: this.form.customer_name,
            };

            if (customerIndex === -1) {
              this.list.filter_customers.push(documentCustomer);
            } else {
              this.list.filter_customers.splice(customerIndex, 1, documentCustomer);
            }
          }

          this.form.is_delivery_address =
            res.result.customer_is_delivery_address;
          this.isActiveTaxYearInit = this.form.is_one_year_extension_tax;
          this.isActiveTaxYearEnd = this.form.is_two_year_extension_tax;
          if (this.form.product.length === 0) {
            this.form.product = [
              {
                broker: '',
                category_id: 'PC1',
                discount: 0,
                name: '',
                price: 0,
                product_id: '',
                product_type: '',
                sku_code: '',
                sku_detail: '',
                sub_category_id: '',
                sub_category_name: '',
                vat: 0,
                vat_price: 0,
                start_date: moment()
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                end_date: moment()
                  .add(1, 'years')
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                product_price: 0,
              },
              {
                broker: '',
                category_id: 'PC2',
                discount: 0,
                name: '',
                price: 0,
                product_id: '',
                product_type: '',
                sku_code: '',
                sub_category_id: '',
                sub_category_name: '',
                type: 0,
                vat: 0,
                vat_price: 0,
                start_date: moment()
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                end_date: moment()
                  .add(1, 'years')
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                product_price: 0,
              },
              {
                category_id: '',
                discount: 0,
                message_on_select: '',
                name: '',
                price: 0,
                product_id: '',
                product_type: '',
                sub_category_id: '',
                sub_category_name: '',
                vat: 0,
                vat_price: 0,
                product_price: 0,
              },
            ];
          } else {
            this.productFormat();
          }
          if (options.beforeHydration) await options.beforeHydration;
          if (requestSeq !== this.documentLoadRequestSeq) return false;
          const hydrationTasks = [
            this.getCarById(this.form.car_id, false, true, requestSeq),
            this.getCustomerById(this.form.customer_id, {
              source: this.customerSource,
              customerName: this.form.customer_name,
            }),
          ];
          if (this.form.status == 1 || this.form.status == 2) {
            hydrationTasks.push(this.getApprovalById(this.form.approval_id));
          }
          await Promise.all(hydrationTasks);
          if (requestSeq !== this.documentLoadRequestSeq) return false;
          if (!options.deferPrint) await this.getDataPrint();
          return true;
          })
          .catch((err) => {
            console.error('err', err);
            throw err;
          });
      } finally {
        if (options.manageLoading !== false) this.loading = false;
        await new Promise((resolve) => this.$nextTick(resolve));
        this.documentHydrationDepth--;
      }
    },
    changeIsFullYear(val, index) {
      if (val) {
        this.form.product[index].end_date = moment(
          this.form.product[index].start_date
        )
          .add(1, 'year')
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
      }
      if (index == 0) this.cal_ins_not_full_year();
    },
    async save(isClose = false) {
      if (!this.formHydrationReady) return;
      this.normalizeUnselectedInsuranceProduct();
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.valid = true;
      this.errors = {};
      this.loading = true;
      let errors = [];
      this.addElectricVehicleWeightError(errors);
      if (['CT1', 'CT2', 'CT3', 'CT12'].includes(this.form.car_type)) {
        if (
          !(
            this.form.car_type == 'CT2' ||
            this.form.car_type == 'CT3' ||
            this.form.car_fuel == 3
          ) &&
          this.form.engine_size == '' &&
          !this.detailCar
        ) {
          this.errors.engine_size = 'ข้อมูลไม่ถูกต้อง.';
          errors.push('กรุณาระบุขนาดเครื่องยนต์');
          this.valid = false;
        }
        if (
          !(this.form.car_type == 'CT1' || this.form.car_type == 'CT12') &&
          this.form.car_weight == '' &&
          !this.detailCar
        ) {
          this.errors.car_weight = 'ข้อมูลไม่ถูกต้อง.';
          errors.push('กรุณาระบุน้ำหนักรถ');
          this.valid = false;
        }
      }
      let isProductInvalid = false;
      this.form.product.forEach((item, i) => {
        if (item.product_id != '') {
          isProductInvalid = true;
        }
      });
      if (!isProductInvalid) {
        errors.push('กรุณาระบุสินค้าอย่างน้อย 1 รายการ');
        this.valid = false;
      }
      let isProductPrice = true;
      this.form.product.forEach((item, i) => {
        if (
          (item.product_price != 0 && item.product_id == null) ||
          (item.product_id == null && item.sub_category_id != '')
        ) {
          isProductPrice = false;
        }
      });
      if (!isProductPrice && isProductInvalid) {
        errors.push('กรุณาระบุสินค้าและหมวดหมู่');
        this.valid = false;
      }
      if (this.form.approval == '') {
        errors.push('กรุณาระบุพนักงาน');
        this.valid = false;
      }
      // Error Popup Dialog
      if (errors && errors.length) {
        let htmlMsg = errors.join('<br/>');
        this.$alertServerError({
          title: 'Error',
          html: htmlMsg,
          showConfirmButton: true,
          timer: false,
        });
        this.loading = false;
        this.$v.form.$reset();
      }
      if (this.valid) {
        this.$alertConfirm({ title: `ยืนยันบันทึกข้อมูล ?`, html: '' }).then(
          async (result) => {
            if (result.isConfirmed) {
              this.invalidatePendingQuickProductMutations();
              this.form.detailCustomer = this.detailCustomer;
              this.form.detailCar = this.detailCar;
              this.form.total_price = this.total_price;
              this.form.total_discount = this.total_discount;
              this.form.vat_price = this.vat_price;
              this.form.net_price = this.net_price;
              this.form.temp_product = this.form.product;

              this.form.tax_year_init = this.car_tax.tax_year_init || '';
              this.form.tax_year_ended = this.isActiveTaxYearEnd
                ? this.car_tax.tax_year_ended || ''
                : '';
              this.form.is_one_year_extension_tax = this.isActiveTaxYearInit;
              this.form.is_two_year_extension_tax = this.isActiveTaxYearEnd;
              this.syncTaxRenewalYearToForm();
              var temp_taxout_date = this.form.taxout_date;
              this.form.taxout_date = this.form.bill_taxout_date;
              let subPath = 'add_document';
              if (this.form._id) {
                subPath = 'edit_document';
                this.form = { document_id: this.form._id, ...this.form };
              }
              let sendForm = {
                ...this.form,
                workstation_id: this.customerDisplayWorkstationId(),
                customer_source: this.normalizeCustomerSource(
                  this.customerSource
                ),
                customer_phone_number:
                  this.form.customer_phone_number.replaceAll('-', ''),
              };
              //console.log(sendForm);
              let body = {
                token: this.$jwt.sign(sendForm, this.$privateKey, {
                  noTimestamp: true,
                }),
              };
              await this.$axios
                .post(`${this.$baseUrl}/document/${subPath}`, body)
                .then(async (res) => {
                  this.form.taxout_date = temp_taxout_date;
                  this.$alertSuccess({ title: res.status });
                  this.form.status = 0;
                  //console.log('This is result of save ' + res.result);
                  await this.getDataPrint(res.result);
                  this.customerDisplayMarkSaved(res.result);
                  if (!isClose) {
                    this.$router
                      .push({
                        name: 'document-quotation-update',
                        params: { id: res.result },
                      })
                      .catch(() => {});
                  } else {
                    this.close();
                  }
                })
                .catch((err) => {
                  console.error('err', err);
                });
            }
            this.loading = false;
            this.$v.form.$reset();
          }
        );
      }
    },
    handleClosePay() {
      this.dialogPayChoose = false;
      // this.isEdit = false
      //this.isUpdate = true;
      this.form.status = 1;
    },
    pay() {
      //this.saveNoAlert();
      setTimeout(() => {
        this.$router.push({
          name: 'document-quotation-pay',
          params: { document_id: this.id },
        });
      });
    },
    overdue() {
      this.$alertConfirm({ title: `ยืนยันการค้างชำระ`, text: `` }).then(
        async (result) => {
          if (result.isConfirmed) {
            //this.saveNoAlert();
            this.dialogSuccess = true;
            //     let body = {
            //       token: this.$jwt.sign(
            //         { document_id: this.form._id },
            //         this.$privateKey,
            //         {
            //           noTimestamp: true
            //         }
            //       )
            this.document_id = this.form._id;
            this.isEdit = false;
            this.isUpdate = true;
          }
          //     await this.$axios
          //       .post(`${this.$baseUrl}/document/open_quotation_bill`, body)
          //       .then(async res => {
          //         console.log(res);
        }
      );
    },
    async saveNoAlert(isClose = false) {
      if (!this.formHydrationReady) return;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.valid = true;
      this.errors = {};
      this.loading = true;
      let errors = [];
      this.addElectricVehicleWeightError(errors);
      if (['CT1', 'CT2', 'CT3', 'CT12'].includes(this.form.car_type)) {
        if (
          !(
            this.form.car_type == 'CT2' ||
            this.form.car_type == 'CT3' ||
            this.form.car_fuel == 3
          ) &&
          this.form.engine_size == '' &&
          !this.detailCar
        ) {
          this.errors.engine_size = 'ข้อมูลไม่ถูกต้อง.';
          errors.push('กรุณาระบุขนาดเครื่องยนต์');
          this.valid = false;
        }
        if (
          !(this.form.car_type == 'CT1' || this.form.car_type == 'CT12') &&
          this.form.car_weight == '' &&
          !this.detailCar
        ) {
          this.errors.car_weight = 'ข้อมูลไม่ถูกต้อง.';
          errors.push('กรุณาระบุน้ำหนักรถ');
          this.valid = false;
        }
      }
      let isProductInvalid = false;
      this.form.product.forEach((item, i) => {
        if (item.product_id != '') {
          isProductInvalid = true;
        }
      });
      if (!isProductInvalid) {
        errors.push('กรุณาระบุสินค้าอย่างน้อย 1 รายการ');
        this.valid = false;
      }

      let isProductPrice = true;
      this.form.product.forEach((item, i) => {
        if (
          (item.product_price != 0 && item.product_id == '') ||
          (item.product_id == '' && item.sub_category_id != '')
        ) {
          isProductPrice = false;
        }
      });
      if (!isProductPrice && isProductInvalid) {
        errors.push('กรุณาระบุสินค้าและหมวดหมู่');
        this.valid = false;
      }
      // Error Popup Dialog
      if (errors && errors.length) {
        let htmlMsg = errors.join('<br/>');
        this.$alertServerError({
          title: 'Error',
          html: htmlMsg,
          showConfirmButton: true,
          timer: false,
        });
        this.loading = false;
        this.$v.form.$reset();
      }
      if (this.valid) {
        this.invalidatePendingQuickProductMutations();
        this.form.detailCustomer = this.detailCustomer;
        this.form.detailCar = this.detailCar;
        this.form.total_price = this.total_price;
        this.form.total_discount = this.total_discount;
        this.form.vat_price = this.vat_price;
        this.form.net_price = this.net_price;
        this.form.temp_product = this.form.product;

        this.form.tax_year_init = this.car_tax.tax_year_init || '';
        this.form.tax_year_ended = this.isActiveTaxYearEnd
          ? this.car_tax.tax_year_ended || ''
          : '';
        this.form.is_one_year_extension_tax = this.isActiveTaxYearInit;
        this.form.is_two_year_extension_tax = this.isActiveTaxYearEnd;
        this.syncTaxRenewalYearToForm();
        var temp_taxout_date = this.form.taxout_date;
        this.form.taxout_date = this.form.bill_taxout_date;
        let subPath = 'add_document';
        if (this.form._id) {
          subPath = 'edit_document';
          this.form = { document_id: this.form._id, ...this.form };
        }
        let sendForm = {
          ...this.form,
          workstation_id: this.customerDisplayWorkstationId(),
          customer_source: this.normalizeCustomerSource(this.customerSource),
          customer_phone_number: this.form.customer_phone_number.replaceAll(
            '-',
            ''
          ),
        };
        //console.log(sendForm);
        let body = {
          token: this.$jwt.sign(sendForm, this.$privateKey, {
            noTimestamp: true,
          }),
        };
        await this.$axios
          .post(`${this.$baseUrl}/document/${subPath}`, body)
          .then(async (res) => {
            this.form.taxout_date = temp_taxout_date;
            this.form.status = 0;
            await this.getDataPrint(res.result);
            this.customerDisplayMarkSaved(res.result);
          })
          .catch((err) => {
            console.log('err', err);
          });

        this.loading = false;
      }
    },
    close() {
      this.$router.push({ name: `document-${this.docPath}` });
    },
    async saveClose() {
      this.save(true);
    },
    onSubmitYear(val) {
      this.isEditFilterExpressProduct = true;
      this.form.taxout_date = val;
      this.form.bill_taxout_date = val;
      this.dialogYearChooseData = val;
      this.dialogYearChoose = false;
      this.main_calculate();
    },
    onSubmitAddress(val) {
      this.form[this.dialogAddressKey] = val;
      this.dialogAddress = false;
    },
    onSubmitEditDocument(val) {
      this.$alertConfirm({ title: `ยืนยันบันทึกข้อมูล ?`, text: `` }).then(
        async (result) => {
          if (result.isConfirmed) {
            let sendForm = {
              ...this.dialogEditDocumentData,
              customer_phone_number:
                this.dialogEditDocumentData.customer_phone_number.replaceAll(
                  '-',
                  ''
                ),
            };
            let body = {
              token: this.$jwt.sign(sendForm, this.$privateKey, {
                noTimestamp: true,
              }),
            };
            await this.$axios
              .post(`${this.$baseUrl}/document/edit_data`, body)
              .then(async (res) => {
                if (res.status == 'carExistDatabase') {
                  this.$alertServerError({ title: 'ข้อมูลซ้ำกับในฐานข้อมูล' });
                } else if (res.status == 'success') {
                  this.$alertSuccess({ title: 'ส่งแก้ไขสำเร็จ' });
                  if (!this.list.setting.document_approvement) {
                    let edit_data_approvement_body = {
                      token: this.$jwt.sign(
                        { log_document_id: res.result, approvement: true },
                        this.$privateKey,
                        {
                          noTimestamp: true,
                        }
                      ),
                    };
                    await this.$axios
                      .post(
                        `${this.$baseUrl}/document/edit_data_approvement`,
                        edit_data_approvement_body
                      )
                      .then(async (res) => {
                        this.getData();
                      });
                  }
                }
              })
              .catch((err) => {
                console.error('err', err);
                this.$alertServerError({ title: err.error_message });
              });
          }
        }
      );
      this.dialogEditCar = false;
      this.dialogEditCustomer = false;
    },
    async getDiscountedGroups(options = {}) {
      let filter = {};
      let body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      try {
        let res = await this.$axios.post(`${this.$baseUrl}/discounted_groups/list_group`, body);
        this.list.discounted_groups = res.result;
        if (!options.preserveForm) this.form.discounted_groups_id = res.result[0]._id;
      } catch(error) {
        console.error('getDiscountedGroups Error : ', error);
        if (options.preserveForm) throw error;
      }
    },
    async onCustomerTaxIdVisibilityChange(showCustomerTaxId) {
      const previousValue = this.form.hide_customer_tax_id === true;
      this.$set(this.form, 'hide_customer_tax_id', showCustomerTaxId !== true);
      if (!this.form._id) return;

      this.updatingCustomerTaxIdVisibility = true;
      try {
        const body = {
          token: this.$jwt.sign(
            {
              document_id: this.form._id,
              hide_customer_tax_id: this.form.hide_customer_tax_id,
            },
            this.$privateKey,
            { noTimestamp: true }
          ),
        };
        await this.$axios.post(
          `${this.$baseUrl}/document/set_customer_tax_id_visibility`,
          body
        );
        await this.getDataPrint(this.form._id);
      } catch (err) {
        this.$set(this.form, 'hide_customer_tax_id', previousValue);
        this.$alertServerError({ title: err.error_message || 'บันทึกไม่สำเร็จ' });
      } finally {
        this.updatingCustomerTaxIdVisibility = false;
      }
    },
    async getSetting() {
      try {
        let listFiltered = this.$store.state.list.branchs.filter((el) => {
          return el._id == this.$store.state.selected_branch._id;
        });

        if (listFiltered.length > 0) {
          this.list.setting = listFiltered[0].setting;
          this.thisBranch = listFiltered[0];
          if (!this.$route.params.id) {
            this.$set(
              this.form,
              'hide_customer_tax_id',
              this.list.setting.default_show_customer_tax_id === false
            );
          }
          
          await this.handlePickupDate();
          this.form.pick_up_time = this.form.pick_up_time === ''
            ? this.list.setting.document_pickup_time
            : this.form.pick_up_time;

          this.form.tax_filling_date = this.list.setting.tax_filling_date > this.form.tax_filling_date
            ? this.list.setting.tax_filling_date
            : this.form.tax_filling_date;

          let starting_province = [this.list.setting.starting_province];

          this.list.provinces = starting_province.concat(
            this.list.provinces.filter((value) => {
              return starting_province.indexOf(value) === -1;
            })
          );
        } else {
          console.error('No matching branch found.');
        }
      } catch (err) {
        console.error('Error in getSetting:', err);
      }
    },
    async handlePickupDate() {
      let document_pickup_date = parseInt(
        this.list.setting.document_pickup_date
      );
      let days = 0;
      let number = 0;
      let day = 0;
      while (day < document_pickup_date) {
        let day_number = await moment().add(days, 'days').day();
        days++;
        if (day_number == 0 || day_number == 6) {
          number++;
        } else {
          day++;
        }
      }
      let totalDays = document_pickup_date + number;
      this.form.pick_up_date = moment()
        .add(totalDays - 1, 'days')
        .format('YYYY-MM-DD');
    },
    async getApprovalById(approval_id, requestSeq = this.documentLoadRequestSeq) {
      this.form.approval_id = approval_id;
      const body = {
        token: this.$jwt.sign({ user_id: approval_id }, this.$privateKey, {
          noTimestamp: true,
        }),
      };

      try {
        let data;
        if (approval_id == this.$store.state.profile._id) {
          data = this.$store.state.profile;
        } else {
           let res = await this.$axios.post(
          `${this.$baseUrl}/users/get_by_id`,
          body
        );
          data = res.result;
        };
       
        if (requestSeq !== this.documentLoadRequestSeq || this._isBeingDestroyed) return;
        if (data) {
          this.approvals = data;
          this.form.approval_id = data._id;
          this.form.approval = data.name;
        };
      } catch (err) {
        console.error('err', err);
      }
    },

    isCustomerRequestCurrent(
      requestSeq,
      customerId,
      source,
      carInfoKey = '',
      carInfoRequestSeq = null
    ) {
      const isCurrentCustomer =
        requestSeq === this.customerRequestSeq &&
        this.form.customer_id === customerId &&
        this.customerSource === source;

      if (!carInfoKey) return isCurrentCustomer;

      return (
        isCurrentCustomer &&
        carInfoRequestSeq === this.carInfoRequestSeq &&
        carInfoKey === this.getCarInfoKey()
      );
    },
    normalizeCustomerSource(source) {
      const customerSources = [
        'manual-entry',
        'manual-selected',
        'car-owner',
        'document-unknown',
      ];

      return customerSources.includes(source) ? source : 'document-unknown';
    },
    startManualCustomerEntry(customerName = this.customer_name_search) {
      const manualName = customerName || '';

      this.customerRequestSeq++;
      const requestSeq = this.customerRequestSeq;
      this.customerSource = 'manual-entry';
      this.customerSelectedName = '';
      this.temp_customer = { _id: '', name: manualName };
      this.resetForm(manualName);

      // Vuetify can restore its previous search text after Vue's next tick.
      setTimeout(() => {
        if (
          requestSeq === this.customerRequestSeq &&
          this.customerSource === 'manual-entry'
        ) {
          this.customer_name_search = manualName;
        }
      }, 0);
    },
    handleCustomerSelection(customer) {
      this.cancelCustomerSearch();
      this.customerSearchRequestSeq++;

      if (!customer || !customer._id) {
        this.startManualCustomerEntry(this.customer_name_search);
        return;
      }

      this.getCustomerById(customer._id, {
        source: 'manual-selected',
        customerName: customer.name,
      });
    },
    async getCustomerById(
      customer_id,
      {
        source = 'manual-selected',
        customerName = '',
        carInfoKey = '',
        carInfoRequestSeq = null,
      } = {}
    ) {
      if (!customer_id) {
        this.startManualCustomerEntry(this.customer_name_search);
        return;
      }

      const requestSeq = ++this.customerRequestSeq;
      this.form.customer_id = customer_id;
      this.customerSource = source;
      this.customerSelectedName = customerName || '';
      const isCurrentRequest = () =>
        this.isCustomerRequestCurrent(
          requestSeq,
          customer_id,
          source,
          carInfoKey,
          carInfoRequestSeq
        );
      let body = {
        token: this.$jwt.sign({ customer_id: customer_id }, this.$privateKey, { noTimestamp: true })
      };

      try {
        const response = await this.$axios.post(`${this.$baseUrl}/customer/get_by_id`, body);
        const data = response.result;

        if (data && isCurrentRequest()) {
          this.customerSelectedName = data.name;
          this.populateFormWithCustomerData(data);
          if (!this.isUpdate) {
          }
        }
      } catch (error) {
        console.error('Error fetching customer by ID:', error);
      }

      if (
        isCurrentRequest() &&
        !this.form.customer_phone_number
      ) {
        this.toggleShowPhoneNumber = true;
      }
    },

    resetForm(customerName = this.customer_name_search) {
      this.customer = '';
      this.form.customer_id = '';
      this.form.customer_name = customerName;
      this.form.customer_address = this.emptyAddress();
      this.form.customer_phone_number = this.parsePhonePattern('', true);
      this.form.customer_taxpayer_number = '';
      this.form.customer_company_branch = '';
      this.form.customer_note = '';
      this.form.is_delivery_address = false;
      this.form.customer_delivery_address = this.emptyAddress();
      this.form.call_alert = false;
      this.form.call_remind_renewal = false;
      if (this.list.discounted_groups.length > 0) {
        this.form.discounted_groups_id = this.list.discounted_groups[0]._id;
      }
    },

    populateFormWithCustomerData(data) {
      this.customer = data;
      if (!this.list.filter_customers.some((item) => item._id === data._id)) {
        this.list.filter_customers.push({ _id: data._id, name: data.name });
      }
      this.setCustomerSearchValue(data.name);
      this.form.customer_name = data.name;
      this.form.customer_address = data.location || this.emptyAddress();
      this.form.customer_phone_number = this.parsePhonePattern(data.phone_number, true);
      this.form.customer_taxpayer_number = data.taxpayer_number;
      this.form.customer_company_branch = data.company_branch;
      this.form.customer_note = data.note;
      this.form.customer_delivery_address = data.delivery_address || this.emptyAddress();
      this.form.call_alert = data.call_alert;
      this.form.call_remind_renewal = data.call_remind_renewal;
      this.form.discounted_groups_id = data.customer_group || this.list.discounted_groups[0]._id;
    },

    emptyAddress() {
      return {
        address: '',
        district: '',
        sub_district: '',
        province: '',
        postal_code: '',
      };
    },
    setCustomerSearchValue(customerName) {
      this.isSyncingCustomerSearch = true;
      this.customer_name_search = customerName;
      this.$nextTick(() => {
        this.isSyncingCustomerSearch = false;
      });
    },
    cancelCustomerSearch() {
      if (this.customerSearchTimeout) {
        clearTimeout(this.customerSearchTimeout);
        this.customerSearchTimeout = null;
      }

      if (this.customerSearchCancelSource) {
        this.customerSearchCancelSource.cancel('Customer search superseded');
        this.customerSearchCancelSource = null;
      }
    },
    clearCustomerFromPreviousCarOwner() {
      this.customerRequestSeq++;
      this.customerSource = 'manual-entry';
      this.customerSelectedName = '';
      this.temp_customer = { _id: '', name: '' };
      this.cancelCustomerSearch();
      this.customer_name_search = '';
      this.resetForm('');
    },

    async getCarById(
      car_id,
      isGetCustomer = true,
      preserveDocumentSnapshot = false,
      documentRequestSeq = null
    ) {
      const isCurrentDocumentRequest = () =>
        documentRequestSeq === null ||
        documentRequestSeq === this.documentLoadRequestSeq;
      const hasCompleteSnapshot =
        preserveDocumentSnapshot &&
        Number(this.form.car_snapshot_version) >= 1;
      const isLegacyDocument =
        preserveDocumentSnapshot && !hasCompleteSnapshot;

      if (preserveDocumentSnapshot) {
        const plateParts = String(this.form.car_plate || '').split(' ');
        this.temp_car.plate_character =
          this.form.car_plate_character || plateParts.shift() || '';
        this.temp_car.plate_number =
          this.form.car_plate_number || plateParts.join(' ') || '';
        this.temp_car.plate_province =
          this.form.car_plate_province || this.form.car_province || '';
      }

      if (car_id) {
        let body = {
          token: this.$jwt.sign({ car_id: car_id }, this.$privateKey, {
            noTimestamp: true,
          }),
        };
        await this.$axios
          .post(`${this.$baseUrl}/car/get_by_id`, body)
          .then(async (res) => {
            if (!isCurrentDocumentRequest()) return false;
            let data = res.result;
            this.car = data;
            if (!preserveDocumentSnapshot) {
              this.temp_car.plate_character = data.plate_character;
              this.temp_car.plate_number = data.plate_number;
              this.temp_car.plate_province = data.plate_province;
            }

            if (!hasCompleteSnapshot) {
              if (isLegacyDocument) {
                const plateParts = String(this.form.car_plate || '').split(' ');
                this.form.car_plate_character =
                  this.form.car_plate_character ||
                  plateParts.shift() ||
                  data.plate_character;
                this.form.car_plate_number =
                  this.form.car_plate_number ||
                  plateParts.join(' ') ||
                  data.plate_number;
                this.form.car_plate_province =
                  this.form.car_plate_province ||
                  this.form.car_province ||
                  data.plate_province;
                this.temp_car.plate_character = this.form.car_plate_character;
                this.temp_car.plate_number = this.form.car_plate_number;
                this.temp_car.plate_province = this.form.car_plate_province;
              } else {
                this.form.car_plate_character = data.plate_character;
                this.form.car_plate_number = data.plate_number;
                this.form.car_plate_province = data.plate_province;
                this.form.car_type = data.car_type;
                this.form.registration_date = data.registration_date;
                this.form.taxout_date = data.taxout_date;
                this.form.is_original_document = data.is_original_document;
              }
              this.$set(this.form, 'car_weight', data.car_weight);
              this.$set(this.form, 'engine_size', data.engine_size);
              this.$set(this.form, 'extra_fuel', data.extra_fuel || 0);
              this.$set(this.form, 'car_fuel', data.car_fuel || 0);
              this.$set(
                this.form,
                'is_corporation_car',
                Boolean(data.is_corporation_car)
              );
            }
            this.$set(
              this.form,
              'car_registration_url',
              this.form.car_registration_url || data.car_registration_url || ''
            );
            // console.log(this.form.taxout_date)
            // console.log(this.form.status)
            // if(this.form.status!=1 && this.$route.params.id){
            //   this.form.taxout_date = data.taxout_date!="Invalid date" ? data.taxout_date : this.form.taxout_date;
            // }else{
            //   this.form.taxout_date = this.form.taxout_date
            // }
            if (data.ownership.customer_id && isGetCustomer) {
              this.form.car_id = car_id;
              this.getCustomerById(data.ownership.customer_id, {
                source: 'car-owner',
                customerName: data.ownership.customer_name,
              });
            }
            // this.form.project_name = data.plate_character + ' ' + data.plate_number + ' ' + data.plate_province
          })
          .catch((err) => {
            console.error('err', err);
          });
      } else {
        this.form.car_plate_character = this.temp_car.plate_character;
        this.form.car_plate_number = this.temp_car.plate_number;
        this.form.car_plate_province = this.temp_car.plate_province;
        // this.form.project_name = this.temp_car.plate_character + ' ' + this.temp_car.plate_number + ' ' + this.temp_car.plate_province
        this.form.registration_date = moment()
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
        this.form.taxout_date = moment()
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
        this.form.bill_taxout_date = moment()
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
      }
    },
    async changePlateProvince(val) {
      this.temp_car.plate_province = val;
      // this.form.project_name = this.form.project_name.split(' ').splice(0,2).join(' ')+' '+val
    },
    getExpressProductDiscountedGroupId() {
      return (
        this.form.discounted_groups_id ||
        (this.list.discounted_groups[0]
          ? this.list.discounted_groups[0]._id
          : '')
      );
    },
    getExpressProductFilterKey() {
      const discountedGroupId = this.getExpressProductDiscountedGroupId();
      if (
        !discountedGroupId ||
        !this.form.car_type ||
        !EXPRESS_PRODUCT_CAR_TYPES.includes(this.form.car_type)
      ) {
        return '';
      }

      const extraFuel =
        this.form.extra_fuel === null ||
        typeof this.form.extra_fuel === 'undefined'
          ? ''
          : this.form.extra_fuel;
      const carFuel =
        this.form.car_fuel === null ||
        typeof this.form.car_fuel === 'undefined'
          ? ''
          : this.form.car_fuel;

      return [
        discountedGroupId,
        this.form.car_type,
        this.form.car_weight || '',
        this.form.engine_size || '',
        extraFuel,
        carFuel,
      ].join('|');
    },
    addElectricVehicleWeightError(errors) {
      const weightError = getElectricVehicleWeightError(
        this.form.car_fuel,
        this.form.car_weight
      );
      if (!weightError) return;
      this.errors.car_weight = weightError;
      if (!errors.includes(weightError)) errors.push(weightError);
      this.valid = false;
    },
    setQuickCarSpecification(field, value) {
      const previousValue = this.form[field];

      if (
        this.loading ||
        (this.isUpdate && this.form.status != 0) ||
        String(previousValue) === String(value)
      ) {
        return;
      }

      this.$set(this.form, field, value);
      this.queueExpressProductRefresh(value, previousValue);
    },
    queueExpressProductRefresh(newVal, oldVal) {
      if (
        newVal === oldVal ||
        this.loading ||
        this.documentHydrationDepth > 0 ||
        this.expressProductRefreshSuppressions > 0
      ) {
        return;
      }

      const expressProductKey = this.getExpressProductFilterKey();
      if (!expressProductKey) return;

      if (this.expressProductRefreshTimeout) {
        if (expressProductKey === this.pendingExpressProductKey) return;
        clearTimeout(this.expressProductRefreshTimeout);
      }

      this.pendingExpressProductKey = expressProductKey;
      const vehicleProductReapplySeq = ++this.vehicleProductReapplySeq;
      const documentProductWriteVersion = this.documentProductWriteVersion;
      this.expressProductRefreshTimeout = setTimeout(async () => {
        this.expressProductRefreshTimeout = null;

        if (
          vehicleProductReapplySeq !== this.vehicleProductReapplySeq ||
          documentProductWriteVersion !== this.documentProductWriteVersion ||
          expressProductKey !== this.getExpressProductFilterKey() ||
          this.loading ||
          this.documentHydrationDepth > 0 ||
          this.expressProductRefreshSuppressions > 0
        ) {
          if (this.pendingExpressProductKey === expressProductKey) {
            this.pendingExpressProductKey = '';
          }
          return;
        }

        this.pendingExpressProductKey = '';
        await this.main_calculate();
        if (
          vehicleProductReapplySeq !== this.vehicleProductReapplySeq ||
          documentProductWriteVersion !== this.documentProductWriteVersion ||
          this.documentHydrationDepth > 0
        ) {
          return;
        }
        const isCatalogCurrent = await this.getExpressProduct();
        if (
          vehicleProductReapplySeq !== this.vehicleProductReapplySeq ||
          documentProductWriteVersion !== this.documentProductWriteVersion ||
          this.documentHydrationDepth > 0 ||
          !isCatalogCurrent
        ) {
          return;
        }
        this.recalculateVehicleDocumentProducts(documentProductWriteVersion);
      }, 300);
    },
    invalidatePendingVehicleProductReapply() {
      this.vehicleProductReapplySeq++;
      this.carInfoRequestSeq++;
      this.pendingCarInfoKey = '';
      this.pendingExpressProductKey = '';
      if (this.expressProductRefreshTimeout) {
        clearTimeout(this.expressProductRefreshTimeout);
        this.expressProductRefreshTimeout = null;
      }
    },
    invalidatePendingThirdInsuranceSelection() {
      this.thirdInsuranceProductRequestSeq++;
      this.thirdInsuranceSelectionSeq++;
    },
    invalidatePendingQuickProductMutations() {
      this.documentProductWriteVersion++;
      this.invalidatePendingVehicleProductReapply();
      this.invalidatePendingThirdInsuranceSelection();
    },
    getCarInfoKey() {
      const plate_character = String(this.temp_car.plate_character || '').trim();
      const plate_number = String(this.temp_car.plate_number || '').trim();
      const plate_province = String(this.temp_car.plate_province || '').trim();

      if (!plate_character || !plate_number || !plate_province) return '';
      return [plate_character, plate_number, plate_province].join('|');
    },
    async getCarByInfo(requestCarInfoKey = this.getCarInfoKey(), requestSeq = this.carInfoRequestSeq) {
      if (!requestCarInfoKey) return false;
      const documentProductWriteVersion = this.documentProductWriteVersion;

      let body = {
        token: this.$jwt.sign(
          {
            branch_id: this.form.branch_id,
            plate_character: this.temp_car.plate_character,
            plate_number: this.temp_car.plate_number,
            plate_province: this.temp_car.plate_province,
          },
          this.$privateKey,
          { noTimestamp: true }
        ),
      };
      let isSuccess = false;
      let isSuppressingExpressProductRefresh = false;

      try {
        const res = await this.$axios.post(`${this.$baseUrl}/car/get_by_info`, body);

        if (
          requestSeq !== this.carInfoRequestSeq ||
          documentProductWriteVersion !== this.documentProductWriteVersion ||
          this.documentHydrationDepth > 0 ||
          requestCarInfoKey !== this.getCarInfoKey()
        ) {
          return false;
        }

        this.expressProductRefreshSuppressions++;
        isSuppressingExpressProductRefresh = true;

        let data = res.result;
        this.car = data;
        this.form.car_plate_character = data.plate_character;
        this.form.car_plate_number = data.plate_number;
        this.form.car_plate_province = data.plate_province;
        this.form.car_type = data.car_type || 'CT1';
        this.$set(this.form, 'car_weight', data.car_weight);
        this.$set(this.form, 'engine_size', data.engine_size);
        this.form.registration_date = data.registration_date;
        this.form.car_registration_url = data.car_registration_url;
        this.form.taxout_date = data.taxout_date;
        this.form.bill_taxout_date = data.taxout_date;
        this.form.is_original_document = data.is_original_document;
        this.$set(this.form, 'extra_fuel', data.extra_fuel || 0);
        this.$set(this.form, 'car_fuel', data.car_fuel || 0);
        this.$set(
          this.form,
          'is_corporation_car',
          Boolean(data.is_corporation_car)
        );

        if (data.ownership.customer_id) {
          this.form.car_id = data._id;
          await this.getCustomerById(data.ownership.customer_id, {
            source: 'car-owner',
            customerName: data.ownership.customer_name,
            carInfoKey: requestCarInfoKey,
            carInfoRequestSeq: requestSeq,
          });
        } else {
          this.$set(this.form, 'car_fuel', 0);
          if (this.customerSource === 'car-owner') {
            this.clearCustomerFromPreviousCarOwner();
          }
        }

        if (
          requestSeq !== this.carInfoRequestSeq ||
          documentProductWriteVersion !== this.documentProductWriteVersion ||
          this.documentHydrationDepth > 0 ||
          requestCarInfoKey !== this.getCarInfoKey()
        ) {
          return false;
        }

        isSuccess = true;
      } catch (err) {
        console.error('err', err);
      } finally {
        if (isSuppressingExpressProductRefresh) {
          await new Promise((resolve) => this.$nextTick(resolve));
          this.expressProductRefreshSuppressions--;
        }
      }

      if (
        this.temp_car.plate_character != '' &&
        this.temp_car.plate_number != '' &&
        this.temp_car.plate_province != ''
      ) {
        this.form.car_id = '';
        // this.form.project_name = this.temp_car.plate_character + ' ' + this.temp_car.plate_number + ' ' + this.temp_car.plate_province
        this.form.car_plate_character = this.temp_car.plate_character;
        this.form.car_plate_number = this.temp_car.plate_number;
        this.form.car_plate_province = this.temp_car.plate_province;
      }

      if (!isSuccess) return false;

      const vehicleProductReapplySeq = ++this.vehicleProductReapplySeq;
      await this.main_calculate();
      if (
        vehicleProductReapplySeq !== this.vehicleProductReapplySeq ||
        documentProductWriteVersion !== this.documentProductWriteVersion ||
        this.documentHydrationDepth > 0
      )
        return false;
      const isCatalogCurrent = await this.getExpressProduct();
      if (
        !isCatalogCurrent ||
        vehicleProductReapplySeq !== this.vehicleProductReapplySeq ||
        documentProductWriteVersion !== this.documentProductWriteVersion ||
        this.documentHydrationDepth > 0
      )
        return false;
      this.recalculateVehicleDocumentProducts(documentProductWriteVersion);
      return true;
    },
    async getDocumentNote() {
        try {
          const filter = {
            branch_id: this.$store.state.selected_branch._id,
            document_type: this.docTypeId,
          };
          const body = {
            token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
          };

          const response = await this.$axios.post(`${this.$baseUrl}/branch/get_document_note`, body);
          this.form.note = response.result.note;
        } catch (error) {
          this.$captureException(error, { source: 'quotation.Detail.getDocumentNote' });
        }
    },
    // async getProvinces() {
    //    this.list.provinces = this.$store.state.list.provinces
    // },
    async changeThirdInsurance(data, { preserveDates = false } = {}) {
      this.form.product[0].broker = data.broker;
      this.form.product[0].product_id = data.product_id;
      this.form.product[0].category_id = data.category_id;
      this.form.product[0].sub_category_id = data.sub_category_id;
      this.form.product[0].sub_category_name = data.sub_category_name;
      this.form.product[0].name = data.name;
      this.form.product[0].discount = data.discount;
      this.form.product[0].price = data.price;
      this.form.product[0].product_price = data.price;
      this.form.product[0].original_product_price =
        data.original_product_price === undefined
          ? data.price
          : data.original_product_price;
      this.form.product[0].total_price = data.total_price;
      this.form.product[0].product_type = data.product_type;
      this.form.product[0].sku_code = data.sku_code;
      this.form.product[0].sku_detail = data.sku_detail;
      this.form.product[0].vat = data.vat;
      this.form.product[0].vat_price = data.vat_price;
      this.form.product[0].is_add1day = data.is_add1day;
      if (!preserveDates) {
        this.form.product[0].start_date = moment()
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
        this.form.product[0].end_date = moment()
          .add(1, 'years')
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
        this.is_full_year = true;
        this.cal_ins_not_full_year();
      }
    },
    async changeInsurance(data) {
      this.form.product[1].broker = data.broker;
      this.form.product[1].product_id = data.product_id;
      this.form.product[1].category_id = data.category_id;
      this.form.product[1].sub_category_id = data.sub_category_id;
      this.form.product[1].sub_category_name = data.sub_category_name;
      this.form.product[1].name = data.name;
      this.form.product[1].discount = data.discount;
      this.form.product[1].price = data.total_price;
      this.form.product[1].product_price = data.total_price;
      this.form.product[1].total_price = data.total_price;
      this.form.product[1].product_type = data.product_type;
      this.form.product[1].sku_code = data.sku_code;
      this.form.product[1].type = data.type;
      this.form.product[1].vat = data.vat;
      this.form.product[1].vat_price = data.vat_price;
      this.form.product[1].start_date = moment()
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DDTHH:mm:ss');
      this.form.product[1].end_date = moment()
        .add(1, 'years')
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DDTHH:mm:ss');
      this.is_insurance_full_year = true;
      this.handleProductPrice(1, 'product_price', data.total_price);
    },
    async getProduct() {
      const filter = {
          branch_id: this.$store.state.selected_branch._id,
          discounted_groups_id: this.form.discounted_groups_id,
        };
        const body = {
          token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
        };
      try {
        const res = await this.$axios.post(`${this.$baseUrl}/document/get_product`, body);
        this.list.product = res.result;
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    },
    async changeProduct(val, index) {
      this.form.product[index].category_id = val.category_id;
      this.form.product[index].detail = val.detail;
      this.form.product[index].discount = val.discount;
      this.form.product[index].message_on_select = val.message_on_select;
      this.form.product[index].name = val.name;
      this.form.product[index].product_id = val.product_id;
      this.form.product[index].product_type = val.product_type;
      this.form.product[index].sub_category_id = val.sub_category_id;
      this.form.product[index].sub_category_name = val.sub_category_name;
      this.form.product[index].tag = val.tag;
      this.form.product[index].vat = val.vat;
      this.form.product[index].product_price = val.price;
      if (val.vat == 1)
        this.form.product[index].vat_price =
          ((val.price - val.discount) * 7) / 100;
      else this.form.product[index].vat_price = 0;
      this.form.product[index].price =
        val.price + this.form.product[index].vat_price;

      if (val.tag === 'tax_include_fines') {
        await this.main_calculate();
        this.applyTaxProductCalculation(this.form.product[index]);
      }
    },
    addProduct() {
      this.form.product.push({
        category_id: '',
        discount: 0,
        message_on_select: '',
        name: '',
        price: 0,
        product_id: '',
        product_type: '',
        sub_category_id: '',
        sub_category_name: '',
        vat: 0,
        vat_price: 0,
        product_price: 0,
      });
    },
    deleteProduct(index) {
      this.form.product.splice(index, 1);
      if (index == 0) {
        let data = {
          category_id: 'PC1',
          discount: 0,
          broker: '',
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sku_code: '',
          sku_detail: '',
          sub_category_id: '',
          sub_category_name: '',
          total_price: 0,
          vat: 0,
          vat_price: 0,
          start_date: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          end_date: moment()
            .add(1, 'years')
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          product_price: 0,
        };
        this.form.product.splice(0, 0, data);
      } else if (index == 1) {
        let data = {
          category_id: 'PC2',
          discount: 0,
          broker: '',
          name: '',
          sku_code: '',
          price: 0,
          product_id: '',
          product_type: '',
          sub_category_id: '',
          sub_category_name: '',
          total_price: 0,
          type: 0,
          vat: 0,
          vat_price: 0,
          start_date: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          end_date: moment()
            .add(1, 'years')
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          product_price: 0,
        };
        this.form.product.splice(1, 0, data);
      } else if (this.form.product.length == 1) {
        this.addProduct();
      }
    },
    async getApproval(text = '') {
      if (this._isBeingDestroyed || this._isDestroyed) return;
      if (this.approvalCancelSource) this.approvalCancelSource.cancel('Approval lookup superseded');
      const cancelSource = this.$axios.CancelToken.source();
      this.approvalCancelSource = cancelSource;
      const isCurrent = () => !this._isBeingDestroyed && !this._isDestroyed &&
        this.approvalCancelSource === cancelSource;
      let filter = {
        item_per_page: 50,
        page: 1,
        start_with: text,
      };
      let body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      try {
        let res = await this.$axios.post(
          `${this.$baseUrl}/users/get_user`,
          body,
          { cancelToken: cancelSource.token }
        );
        if (!isCurrent()) return;
        this.list.approval = res.result.data;
      } catch (err) {
        if (!isCurrent() || this.$axios.isCancel(err)) return;
        console.error('err', err);
        this.$alertServerError({ title: (err && err.error_message) || 'ไม่สามารถโหลดรายชื่อผู้อนุมัติได้ กรุณาลองใหม่' });
      } finally {
        if (this.approvalCancelSource === cancelSource) this.approvalCancelSource = null;
      }
    },

    async getCustomersLimit(
      text = '',
      requestSeq = ++this.customerSearchRequestSeq
    ) {
      if (text.length < 3) return;

      const filter = {
        branch_id: this.$store.state.selected_branch._id,
        start_with: text,
      };
      const body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      this.cancelCustomerSearch();
      const cancelSource = this.$axios.CancelToken.source();
      this.customerSearchCancelSource = cancelSource;

      try {
        const res = await this.$axios.post(
          `${this.$baseUrl}/customer/get_customer_list`,
          body,
          { cancelToken: cancelSource.token }
        );

        if (requestSeq !== this.customerSearchRequestSeq) return;

        if (this.temp_customer.name !== '') {
          this.list.filter_customers = [].concat(this.temp_customer, res.result);
        } else {
          this.list.filter_customers = res.result;
        }
      } catch (err) {
        if (this.$axios.isCancel(err)) return;
        if (requestSeq !== this.customerSearchRequestSeq) return;

        console.error('err', err);
        this.$alertServerError({ title: err.error_message });
      } finally {
        if (this.customerSearchCancelSource === cancelSource) {
          this.customerSearchCancelSource = null;
        }
      }
    },
    async getCars(text = '') {
      let filter = {
        branch_id: this.$store.state.selected_branch._id,
        item_per_page: 10,
        page: 1,
        start_with: text,
      };
      let body = {
        token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/car/get_car`, body)
        .then((res) => {
          if (
            !(
              this.temp_car.plate_character === '' &&
              this.temp_car.plate_number === ''
            )
          ) {
            this.list.cars = [].concat([this.temp_car], res.result.data);
          } else {
            this.list.cars = res.result.data;
          }
        })
        .catch((err) => {
          console.error('err', err);
          this.$alertServerError({ title: err.error_message });
        });
    },
    async getDataPrint(id = this.$route.params.id, options = {}) {
      const requestGeneration = this.printRequestGuard.begin();
      let branch = this.thisBranch;
      if (typeof id !== 'undefined') {
        let filter = {
          document_id: id,
          branch: {
            is_split_bill: branch.is_split_bill,
            logo_url: branch.logo_url,
            open_hours: branch.open_hours,
            name_for_receipt: branch.name_for_receipt,
            taxpayer_number: branch.taxpayer_number,
            phone_number: branch.phone_number,
            line_id: branch.line_id,
            facebook: branch.facebook,
            location: branch.location,
            company_branch: branch.company_branch,
            qr_code_payment: branch.qr_code_payment,
            split_bill_data: branch.split_bill_data,
            setting: {
              merging_subcategory: branch.setting.merging_subcategory,
              receipt_printing_format: branch.setting.receipt_printing_format,
              enable_product_merging: branch.setting.enable_product_merging,
            },
            split_bill_category: branch.split_bill_category,
          },
          car: {
            registration_date: this.form.registration_date,
          },
        };
        //console.log(filter);
        let body = {
          token: this.$jwt.sign(filter, this.$privateKey, {
            noTimestamp: true,
          }),
        };
        return await this.$axios
          .post(`${this.$baseUrl}/document/print_document_data`, body)
          .then(async (res) => {
            if (!this.printRequestGuard.isCurrent(requestGeneration)) return false;
            if (options.requireCurrentRoute && this.$route.params.id !== id) {
              return false;
            }
            this.dataPrint = res.result;
            this.printKey++;
            return true;
          })
          .catch((err) => {
            console.error('err', err);
            return false;
          });
      }
    },
    handleApproval() {
      setTimeout(() => {
        let text = this.form.approval || '';
        if (String(text).length == 0) {
          this.approvals = null;

          this.form.approval_id = '';
          this.form.approval = '';
        }
        this.getApproval(text);
      }, 250);
    },
    handleCars(key) {
      setTimeout(() => {
        let text = this.form[key] || '';
        this.temp_car[key.replace('car_', '')] = this.form[key];
        if (String(text).length == 0) {
          this.car = null;
          this.form.car_plate_character = '';
          this.form.car_plate_number = '';
          this.form.car_plate_province = '';
          this.form.car_type = 'CT1';
          this.form.car_weight = '';
          this.form.engine_size = '';
          this.form.registration_date = '';
          this.form.taxout_date = '';
          this.form.bill_taxout_date = '';
          this.form.tax_filling_date = '';
          this.form.is_original_document = false;
          this.form.extra_fuel = 0;
          this.form.is_corporation_car = false;
        }
        this.getCars(text);
      }, 250);
    },
    handleCarsPlate() {
      setTimeout(() => {
        this.getCars(this.temp_car.plate_character);
      }, 250);
    },
    handleCarsInfo() {
      if (this.carInfoTimeout) {
        clearTimeout(this.carInfoTimeout);
        this.carInfoTimeout = null;
        this.pendingCarInfoKey = '';
      }

      const carInfoKey = this.getCarInfoKey();

      if (!carInfoKey) {
        this.carInfoRequestSeq++;
        this.lastCarInfoKey = '';
        this.pendingCarInfoKey = '';
        this.carSearching = false;
        return;
      }

      if (
        carInfoKey === this.lastCarInfoKey ||
        carInfoKey === this.pendingCarInfoKey
      ) {
        this.carSearching = !!this.pendingCarInfoKey;
        return;
      }

      this.carSearching = true;
      const requestSeq = ++this.carInfoRequestSeq;
      this.pendingCarInfoKey = carInfoKey;

      this.carInfoTimeout = setTimeout(async () => {
        this.carInfoTimeout = null;
        const isSuccess = await this.getCarByInfo(carInfoKey, requestSeq);

        if (requestSeq === this.carInfoRequestSeq) {
          this.pendingCarInfoKey = '';
          this.carSearching = false;
          if (isSuccess) this.lastCarInfoKey = carInfoKey;
        }
      }, 500);
    },
    preventLeadingSpace(event) {
      // Check if the spacebar is pressed and if the field is empty
      if (event.key === ' ' && !this.customer_name_search) {
        event.preventDefault(); // Prevent space input as the first character
      }
    },
    handleCustomerLimit() {
      const customerName = this.customer_name_search || '';

      this.cancelCustomerSearch();

      const requestSeq = ++this.customerSearchRequestSeq;
      if (customerName.length < 3) return;

      this.customerSearchTimeout = setTimeout(() => {
        this.customerSearchTimeout = null;

        if (
          requestSeq !== this.customerSearchRequestSeq ||
          customerName !== this.customer_name_search
        ) {
          return;
        }

        this.temp_customer = { _id: '', name: customerName };
        this.form.customer_name = customerName;
        this.getCustomersLimit(customerName, requestSeq);
      }, 400);
    },
    async handleProductAllChecked(checked) {
      const documentProductWriteVersion = this.documentProductWriteVersion;
      var inspect_checked = false;
      if (checked) {
        if (['CT1', 'CT2', 'CT3', 'CT12'].indexOf(this.form.car_type) >= 0) {
          let diff1 = moment.duration(
            moment(this.form.tax_filling_date).diff(
              moment(this.form.taxout_date)
            )
          );
          let diff2 = moment.duration(
            moment().diff(moment(this.form.registration_date))
          );
          // ขาดต่อทะเบียนเกิน 1 ปี
          if (diff1.asYears() > 1) inspect_checked = true;
          //  รถรย.12 ที่มี Z > 4 ปี 9 เดือน 1 วัน
          if (this.form.car_type == 'CT12') {
            if (diff2.asMonths() >= 57) inspect_checked = true;
            // รถรย.1, 2, 3 ที่มี Z > 6 ปี 9 เดือน 1 วัน
          } else {
            if (diff2.asMonths() >= 81) inspect_checked = true;
          }
          if (inspect_checked) {
            this.product_selected = ['inspect', 'tax', 'third_insurand'];
          } else {
            this.product_selected = ['tax', 'third_insurand'];
          }
        } else {
          this.product_selected = ['inspect', 'tax', 'third_insurand'];
        }
      } else this.product_selected = [];
      this.product_all = Boolean(checked);
      for (const quickProductRole of ['inspect', 'tax', 'third_insurand']) {
        if (documentProductWriteVersion !== this.documentProductWriteVersion)
          return;
        await this.applyQuickProductRoleChange(
          quickProductRole,
          this.product_selected.indexOf(quickProductRole) !== -1,
          documentProductWriteVersion
        );
      }
    },
    async handleProductChecked(quickProductRole) {
      const documentProductWriteVersion = this.documentProductWriteVersion;
      this.product_all =
        this.product_selected.indexOf('tax') !== -1 &&
        this.product_selected.indexOf('third_insurand') !== -1;
      await this.applyQuickProductRoleChange(
        quickProductRole,
        this.product_selected.indexOf(quickProductRole) !== -1,
        documentProductWriteVersion
      );
    },
    async handleUrgentChecked() {
      const documentProductWriteVersion = this.documentProductWriteVersion;
      const wasTaxSelected = this.product_selected.indexOf('tax') !== -1;
      if (this.isUrgent) {
        if (!wasTaxSelected) this.product_selected.push('tax');
        if (this.product_selected.indexOf('urgent') === -1)
          this.product_selected.push('urgent');
        if (!wasTaxSelected) {
          await this.applyQuickProductRoleChange(
            'tax',
            true,
            documentProductWriteVersion
          );
        }
      } else {
        this.product_selected = this.product_selected.filter(
          (item) => item !== 'urgent'
        );
      }
      if (documentProductWriteVersion !== this.documentProductWriteVersion)
        return;
      await this.applyQuickProductRoleChange(
        'urgent',
        this.isUrgent,
        documentProductWriteVersion
      );
    },
    cloneQuickProduct(data) {
      if (!data) return data;
      return JSON.parse(JSON.stringify(data));
    },
    getDocumentQuickProductRole(item) {
      if (!item) return '';

      const tag = String(item.tag || '');
      if (tag === 'tax_include_fines') return 'tax';
      if (tag === 'urgent') return 'urgent';
      if (tag.indexOf('motorcycle_3rdinsurance') !== -1)
        return 'motorcycle_3rdinsurance';
      if (tag.indexOf('extension_tax_fee') !== -1)
        return 'extension_tax_fee';
      if (tag.indexOf('inspect') !== -1) return 'inspect';

      return '';
    },
    getQuickProductCandidate(quickProductRole) {
      const candidates = {
        inspect: this.list.expressProduct.inspect_product,
        tax: this.list.expressProduct.tax_product,
        extension_tax_fee:
          this.list.expressProduct.extension_tax_fee_product,
        urgent: this.list.expressProduct.urgent_extension_tax_fee_product,
        motorcycle_3rdinsurance:
          this.list.expressProduct.motorcycle_3rdinsurance,
        third_insurand: this.list.expressProduct.third_insurand_product,
      };

      return candidates[quickProductRole] || null;
    },
    getQuickProductRoleChanges(quickProductRole) {
      const roleChanges = {
        inspect: ['inspect'],
        tax: ['tax', 'extension_tax_fee'],
        urgent: ['urgent'],
        third_insurand: ['third_insurand', 'motorcycle_3rdinsurance'],
      };
      return roleChanges[quickProductRole] || [];
    },
    getDocumentQuickProductIndex(quickProductRole) {
      return this.form.product.findIndex(
        (item) => this.getDocumentQuickProductRole(item) === quickProductRole
      );
    },
    getCarTaxPopupType(index, message) {
      if (index === 1) return 'error';
      if (index === 3) return 'info';
      if (index === 4) {
        if (message.indexOf('ขาดเกินปี') !== -1) return 'error';
        if (message.indexOf('ยังไม่ถึงเกณฑ์') !== -1) return 'warning';
        return 'success';
      }
      return 'warning';
    },
    toggleExtraFuel(value) {
      if (this.loading || this.form.status != 0) return;
      this.form.extra_fuel = this.form.extra_fuel == value ? 0 : value;
    },
    toggleElectricFuel() {
      if (this.loading || this.form.status != 0) return;
      this.form.car_fuel = this.form.car_fuel == 3 ? 0 : 3;
    },
    showVehiclePriceChangeNotice() {
      if (this.vehiclePriceChangeNoticeTimeout) {
        clearTimeout(this.vehiclePriceChangeNoticeTimeout);
      }
      this.vehiclePriceChangeNotice = true;
      this.vehiclePriceChangeNoticeTimeout = setTimeout(() => {
        this.vehiclePriceChangeNotice = false;
        this.vehiclePriceChangeNoticeTimeout = null;
      }, 7000);
    },
    applyTaxProductCalculation(product) {
      if (!product) return product;
      product.price = this.car_tax.net_tax_price || 0;
      product.product_price = product.price;
      product.print_detail =
        'ค่าภาษี ' +
        this.total_tax +
        ' บาท และ ค่าปรับล่าช้า ' +
        parseFloat(
          parseFloat(this.car_tax.net_tax_price - this.total_tax).toFixed(2)
        ) +
        ' บาท';
      if (this.tax_penalty <= 0) product.print_detail = '';
      return product;
    },
    async handleCorporationCarChange() {
      const taxProductIndex = this.getDocumentQuickProductIndex('tax');
      const previousTaxPrice =
        taxProductIndex === -1
          ? null
          : this.form.product[taxProductIndex].product_price;

      await this.main_calculate();

      if (taxProductIndex === -1) return;

      this.applyTaxProductCalculation(this.form.product[taxProductIndex]);
      if (
        Number(previousTaxPrice) !==
        Number(this.form.product[taxProductIndex].product_price)
      ) {
        this.showVehiclePriceChangeNotice();
      }
    },
    async handleTaxYearSelection(isTaxYearEnd) {
      if (isTaxYearEnd) {
        this.isActiveTaxYearInit = false;
        this.isActiveTaxYearEnd = !this.isActiveTaxYearEnd;
      } else {
        this.isActiveTaxYearInit = !this.isActiveTaxYearInit;
        this.isActiveTaxYearEnd = false;
      }

      await this.main_calculate();

      const taxProductIndex = this.getDocumentQuickProductIndex('tax');
      if (taxProductIndex !== -1) {
        this.applyTaxProductCalculation(this.form.product[taxProductIndex]);
      }

      this.isEditFilterExpressProduct = true;
    },
    clearThirdInsuranceDocumentProduct() {
      const thirdInsurance = this.form.product[0];
      if (!thirdInsurance) return;
      Object.assign(thirdInsurance, {
        broker: '',
        category_id: 'PC1',
        discount: 0,
        insurance_premium: 0,
        name: '',
        original_product_price: 0,
        price: 0,
        product_id: '',
        product_price: 0,
        product_type: '',
        sku_code: '',
        sku_detail: '',
        sub_category_id: '',
        sub_category_name: '',
        total_price: 0,
        vat: 0,
        vat_price: 0,
        is_add1day: 0,
      });
    },
    ensureGeneralProductRow() {
      if (
        this.form.product.length > 3 &&
        !this.form.product[2].name &&
        !this.form.product[2].detail &&
        !this.form.product[2].price
      ) {
        this.form.product.splice(2, 1);
      }
      if (this.form.product.length != 3 && !this.form.product[2]) {
        this.form.product.push({
          category_id: '',
          discount: 0,
          message_on_select: '',
          name: '',
          price: 0,
          product_id: '',
          product_type: '',
          sub_category_id: '',
          sub_category_name: '',
          vat: 0,
          vat_price: 0,
          product_price: 0,
        });
      }
    },
    async addQuickProductToDocument(quickProductRole) {
      const candidate = this.getQuickProductCandidate(quickProductRole);
      if (!candidate) return false;

      if (quickProductRole === 'third_insurand') {
        const thirdInsurance = this.cloneQuickProduct(candidate);
        this.quickProductRoles.third_insurand = true;
        this.invalidatePendingThirdInsuranceSelection();
        this.changeThirdInsurance(thirdInsurance);
        this.form.product[0].insurance_premium = thirdInsurance.total_price;
        this.checkThirdInsurance = thirdInsurance.product_id;
        await this.getThirdInsuranceProduct(
          thirdInsurance.sub_category_id,
          0,
          false
        );
        return true;
      }

      const documentProduct = this.cloneQuickProduct(candidate);
      if (quickProductRole === 'tax') {
        this.applyTaxProductCalculation(documentProduct);
        this.form.show_pickup = true;
      }
      const documentProductIndex = this.getDocumentQuickProductIndex(
        quickProductRole
      );
      if (documentProductIndex === -1)
        this.form.product.push(documentProduct);
      else this.$set(this.form.product, documentProductIndex, documentProduct);
      return true;
    },
    removeQuickProductFromDocument(quickProductRole) {
      if (quickProductRole === 'third_insurand') {
        this.quickProductRoles.third_insurand = false;
        this.invalidatePendingThirdInsuranceSelection();
        this.clearThirdInsuranceDocumentProduct();
        return;
      }
      this.form.product = this.form.product.filter(
        (item) => this.getDocumentQuickProductRole(item) !== quickProductRole
      );
    },
    async applyQuickProductRoleChange(
      quickProductRole,
      isSelected,
      documentProductWriteVersion = this.documentProductWriteVersion
    ) {
      this.isLoadingProduct = true;
      try {
        await this.main_calculate();
        if (documentProductWriteVersion !== this.documentProductWriteVersion) {
          return false;
        }

        const isCatalogCurrent = await this.getExpressProduct();
        if (
          documentProductWriteVersion !== this.documentProductWriteVersion ||
          !isCatalogCurrent
        ) {
          return false;
        }

        const affectedRoles = this.getQuickProductRoleChanges(quickProductRole);
        for (const affectedRole of affectedRoles) {
          if (isSelected) await this.addQuickProductToDocument(affectedRole);
          else this.removeQuickProductFromDocument(affectedRole);
        }
        this.ensureGeneralProductRow();
        this.normalizeUnselectedInsuranceProduct();
        return true;
      } finally {
        this.isLoadingProduct = false;
      }
    },
    recalculateVehicleDocumentProducts(
      documentProductWriteVersion = this.documentProductWriteVersion
    ) {
      if (
        documentProductWriteVersion !== this.documentProductWriteVersion ||
        this.documentHydrationDepth > 0
      ) {
        return false;
      }

      let hasPriceChanged = false;
      this.form.product.forEach((item, index) => {
        const quickProductRole = this.getDocumentQuickProductRole(item);
        if (
          index === 0 &&
          item.category_id === 'PC1' &&
          this.quickProductRoles.third_insurand
        ) {
          const candidate = this.getQuickProductCandidate('third_insurand');
          if (candidate) {
            const thirdInsurance = this.cloneQuickProduct(candidate);
            const previousPrice = item.product_price;
            this.changeThirdInsurance(thirdInsurance);
            item.insurance_premium = thirdInsurance.total_price;
            this.checkThirdInsurance = thirdInsurance.product_id;
            if (Number(previousPrice) !== Number(item.product_price)) {
              hasPriceChanged = true;
            }
          }
          return;
        }

        if (!quickProductRole) return;
        const candidate = this.getQuickProductCandidate(quickProductRole);
        if (!candidate) return;

        const documentProduct = this.cloneQuickProduct(candidate);
        if (quickProductRole === 'tax') {
          this.applyTaxProductCalculation(documentProduct);
        }
        if (Number(item.product_price) !== Number(documentProduct.product_price)) {
          hasPriceChanged = true;
        }
        Object.assign(item, documentProduct);
      });
      if (hasPriceChanged) this.showVehiclePriceChangeNotice();
      return true;
    },
    hasIncompleteInsuranceProduct() {
      const insurance = this.form.product[1];

      if (!insurance || insurance.category_id !== 'PC2') return false;

      return Boolean(insurance.sub_category_id) !== Boolean(insurance.product_id);
    },
    normalizeUnselectedInsuranceProduct() {
      const insurance = this.form.product[1];

      if (
        !insurance ||
        insurance.category_id !== 'PC2' ||
        insurance.sub_category_id ||
        insurance.product_id
      ) {
        return;
      }

      Object.assign(insurance, {
        broker: '',
        discount: 0,
        insurance_premium: 0,
        name: '',
        original_product_price: 0,
        price: 0,
        product_id: '',
        product_price: 0,
        product_type: '',
        sku_code: '',
        sku_detail: '',
        sub_category_id: '',
        sub_category_name: '',
        total_price: 0,
        type: 0,
        vat: 0,
        vat_price: 0,
      });
    },
    async getExpressProduct(options = {}) {
      const expressProductKey = this.getExpressProductFilterKey();

      if (expressProductKey === this.expressProductLoadedKey) {
        this.isEditFilterExpressProduct = false;
        return true;
      }

      const requestSeq = ++this.expressProductRequestSeq;
      try {
        let filter = {
          branch_id: this.$store.state.selected_branch._id,
          discounted_groups_id: this.getExpressProductDiscountedGroupId(),
          car_type: this.form.car_type,
          car_weight: this.form.car_weight,
          engine_size: this.form.engine_size,
          extra_fuel: this.form.extra_fuel,
          car_fuel: this.form.car_fuel,
        };

        let body = {
          token: this.$jwt.sign(filter, this.$privateKey, { noTimestamp: true }),
        };

        let res = await this.$axios.post(`${this.$baseUrl}/document/get_express_product`, body);

        if (
          requestSeq !== this.expressProductRequestSeq ||
          expressProductKey !== this.getExpressProductFilterKey()
        ) {
          return false;
        }

        let data = res.result;
        this.isEditFilterExpressProduct = false;

        if (typeof data.inspect_product !== 'undefined') {
          this.list.expressProduct.inspect_product =
            this.cloneQuickProduct(data.inspect_product);
        } else {
          this.list.expressProduct.inspect_product = null;
        }

        this.expressInsuranceUnavailable = data.third_insurance_unavailable || null;
        if (typeof data.tax_product !== 'undefined') {
          this.list.expressProduct.tax_product = this.cloneQuickProduct({
            ...data.tax_product,
            product_price: data.tax_product.price,
          });
          this.applyTaxProductCalculation(this.list.expressProduct.tax_product);
        } else {
          this.list.expressProduct.tax_product = null;
        }

        if (
          typeof data.third_insurand_product !== 'undefined' &&
          data.third_insurand_product != null
        ) {
          this.list.expressProduct.third_insurand_product = this.cloneQuickProduct({
            ...data.third_insurand_product,
            product_price: data.third_insurand_product.price,
          });
        } else {
          this.list.expressProduct.third_insurand_product = null;
        }

        if (typeof data.extension_tax_fee_product !== 'undefined') {
          this.list.expressProduct.extension_tax_fee_product =
            this.cloneQuickProduct(data.extension_tax_fee_product);
        } else {
          this.list.expressProduct.extension_tax_fee_product = null;
        }

        if (typeof data.motorcycle_3rdinsurance !== 'undefined') {
          this.list.expressProduct.motorcycle_3rdinsurance =
            this.cloneQuickProduct(data.motorcycle_3rdinsurance);
        } else {
          this.list.expressProduct.motorcycle_3rdinsurance = null;
        }
        if (this.$store.state.selected_branch._id === 'BR20220624143058897611d7x') {
          const urgentProduct = this.list.product.find(
            (item) => item.product_id == 'PD20220822093554095729e8J'
          );
          this.list.expressProduct.urgent_extension_tax_fee_product =
            this.cloneQuickProduct(urgentProduct || null);
        } else {
          this.list.expressProduct.urgent_extension_tax_fee_product = null;
        }

        this.expressProductLoadedKey = expressProductKey;

        return true;
      } catch (err) {
        console.error('Error in getExpressProduct:', err);
        if (options.throwOnError) throw err;
        return false;
      }
    },
    handleProductPrice(index, key = 'discount', val) {
      if (!val.toString().includes(',')) {
        var product_price = this.form.product[index].product_price;
        var discount = this.form.product[index].discount;
        var vat = this.form.product[index].vat;
        var vat_price = this.form.product[index].vat_price;
        var price = this.form.product[index].price;

        if (index == 0) {
          if (key == 'discount') {
            discount = val === '' || val === null ? 0 : parseFloat(val);
            price = product_price - discount;
            vat_price = 0;
          } else if (key == 'product_price') {
            product_price = val === '' || val === null ? 0 : parseFloat(val);
            price = product_price - discount;
          }
        } else if (index == 1) {
          this.form.product[index].insurance_premium = parseFloat(
            parseFloat(product_price).toFixed(2)
          );
          if (key == 'discount') {
            discount = val === '' || val === null ? 0 : parseFloat(val);
            price = product_price - discount;
            vat_price = 0;
          } else if (key == 'product_price') {
            product_price = val === '' || val === null ? 0 : parseFloat(val);
            vat_price = parseFloat(
              parseFloat(product_price - product_price / 1.07).toFixed(2)
            );
            price = product_price - discount;
          }
        } else {
          if (key == 'discount')
            discount = val === '' || val === null ? 0 : parseFloat(val);
          else if (key == 'vat')
            vat = val === '' || val === null ? 0 : parseFloat(val);
          else if (key == 'product_price')
            product_price = val === '' || val === null ? 0 : parseFloat(val);

          if (vat == 1) vat_price = ((product_price - discount) * 7) / 100;
          else vat_price = 0;

          price = product_price - discount + vat_price;
        }

        // edit tax_include_fines detail
        if (
          this.form.product[index].tag == 'tax_include_fines' &&
          this.list.setting.show_late_tax_fine
        ) {
          this.form.product[index].print_detail =
            'ค่าภาษี ' +
            this.total_tax +
            ' บาท และ ค่าปรับล่าช้า ' +
            parseFloat(parseFloat(product_price - this.total_tax).toFixed(2)) +
            ' บาท';
          if (product_price - this.total_tax <= 0) {
            this.form.product[index].print_detail = '';
          }
        }

        this.form.product[index].product_price = parseFloat(
          parseFloat(product_price).toFixed(2)
        );
        this.form.product[index].discount = parseFloat(
          parseFloat(discount).toFixed(2)
        );
        this.form.product[index].price = parseFloat(
          parseFloat(price).toFixed(2)
        );
        this.form.product[index].vat_price =
          index != 0
            ? parseFloat(parseFloat(vat_price).toFixed(2))
            : this.form.product[index].vat_price;
      }
    },

    //ฟังก์ชั่นคำนวณราคาพรบ. แบบไม่เต็มปี
    cal_ins_not_full_year() {
      if (this.form.product[0].price != 0) {
        var is_add1day = this.form.product[0].is_add1day
          ? this.is_full_year
            ? 0
            : 1
          : 0;
        var diff_ins_date = moment
          .duration(
            moment(this.form.product[0].end_date).diff(
              moment(this.form.product[0].start_date)
            )
          )
          .asDays();
        //Bug February has 29 day
        let start_date = moment(this.form.product[0].start_date);
        let end_date = moment(this.form.product[0].end_date);
        let has_leap_year_s = false;
        let has_leap_year_e = false;
        let start_feb29 = moment(start_date.year() + '-02-29');
        let end_feb29 = moment(end_date.year() + '-02-29');
        if (
          start_feb29.isValid() &&
          start_feb29.isBetween(
            start_date,
            moment.max(start_date, end_date),
            null,
            '[]'
          )
        ) {
          has_leap_year_s = true;
        }
        if (
          end_feb29.isValid() &&
          end_feb29.isBetween(
            moment.min(start_date, end_date),
            end_date,
            null,
            '[]'
          )
        ) {
          has_leap_year_e = true;
        }
        if (
          (has_leap_year_s || has_leap_year_e) &&
          this.form.product[0].sub_category_name.indexOf('ทิพย') !== -1
        ) {
          var price_all_day = this.form.product[0].original_product_price / 366;
        } else {
          var price_all_day = this.form.product[0].original_product_price / 365;
        }
        var pxdiff = Number(price_all_day * (diff_ins_date + is_add1day));
        var duty = Math.ceil(pxdiff * 0.004);
        var vat_for_ins = (pxdiff + duty) * 0.07;
        if (!this.is_full_year) {
          var price =
            Math.ceil(
              (parseFloat(pxdiff + duty + vat_for_ins) + Number.EPSILON) * 100
            ) / 100;
          this.form.product[0].insurance_premium = price;
        } else {
          price = this.form.product[0].total_price;
          this.form.product[0].insurance_premium = price;
        }

        if (this.list.setting.third_insurance_tax_scrap == 1)
          price = Math.floor(price);
        else if (this.list.setting.third_insurance_tax_scrap == 2)
          price = Math.ceil(price);
        else if (this.list.setting.third_insurance_tax_scrap >= 3) {
          price = Math.floor(price);
          var price1 = 5 - (price % 5);
          if (this.list.setting.third_insurance_tax_scrap == 3) price += price1;
          else if (this.list.setting.third_insurance_tax_scrap == 4)
            price += price1 + 5;
          else if (this.list.setting.third_insurance_tax_scrap == 5)
            price += price1 + 15;
        }

        this.form.product[0].vat_price = vat_for_ins;
        this.handleProductPrice(0, 'product_price', price);
      }
    },

    // แก้วันขาดภาษี เป็นวันเดียวกับวันจดทะเบียนแต่เป็นปีล่าสุด
    calculateTaxOutDate(registration_date) {
      this.form.taxout_date = moment(registration_date)
        .set({ year: moment().year() })
        .format('YYYY-MM-DDTHH:mm:ss');
      this.form.bill_taxout_date = moment(registration_date)
        .set({ year: moment().year() })
        .format('YYYY-MM-DDTHH:mm:ss');
      this.dialogYearChooseData = this.form.taxout_date;
      this.dialogYearChoose = true;
      this.main_calculate();
    },
    calculatePickupDate(tax_filling_date) {
      let document_pickup_date = parseInt(
        this.list.setting.document_pickup_date - 1
      );

      this.form.pick_up_date = moment(tax_filling_date)
        .add(document_pickup_date, 'days')
        .format('YYYY-MM-DD');
    },
    changeIsFullYearByStartDate(val, full_year, index) {
      this.form.product[index].start_date = val;
      if (full_year) {
        this.form.product[index].end_date = moment(
          this.form.product[index].start_date
        )
          .add(1, 'year')
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
      }
      // if(index==0) this.cal_ins_not_full_year();
    },
    openUrl() {
      setTimeout(() => {
        window.open(this.form.car_registration_url, '_blank');
      }, 300);
    },
    async updateRegistrationUrl(car_registration_url) {
      if (this.form.car_id) {
        let form = {
          car_id: this.form.car_id,
          car_registration_url: car_registration_url,
        };
        this.form.car_registration_url = car_registration_url;
        let body = {
          token: this.$jwt.sign(form, this.$privateKey, {
            noTimestamp: true,
          }),
        };
        await this.$axios
          .post(`${this.$baseUrl}/car/edit_car_registration_url`, body)
          .then((res) => {
            //console.log(form);
          })
          .catch((err) => {
            console.error('err', err);
          });
      }
    },
    async handleEstimateCost(val) {
      this.estimateCost = val;
      this.estimateCostTotal = parseFloat(val.replaceAll(',', '')) * 0.005;
    },
    async getUserGroup() {
      await this.$store.dispatch('getGroupPermissions');
      this.applyGroupPermissions();
    },
    applyGroupPermissions() {
      try {
        this.permission = {
          ...this.permission,
          show_phone_number: this.$store.state.group_permissions.show_phone_number || 0,
        };
        
        if (!this.permission.show_phone_number) {
          this.showPhoneNumber = false;
          this.toggleShowPhoneNumber = false;
        } else {
          this.showPhoneNumber = true;
          this.toggleShowPhoneNumber = true;
        };
      } catch (error) {
        this.showPhoneNumber = false;
        this.toggleShowPhoneNumber = false;
        console.error('Error in getUserGroup:', error);
      };
    },
    async followup() {
      try {
        // Wait for the confirmation dialog to resolve
        const result = await this.$alertConfirm({ title: 'ยืนยัน เพิ่มติดตามงาน ?', text: 'เพิ่มติดตามงานภาษี ในระบบติดตามงาน' });

        // If the user confirmed, proceed with the request
        if (result.isConfirmed) {
          // Create a body with the token
          let body = {
            token: this.$jwt.sign(this.form, this.$privateKey, { noTimestamp: true }),
          };

          try {
            // Send the request to the backend
            const response = await this.$axios.post(`${this.$baseUrl}/document/track_document`, body);

            // Handle the response for action: track_document_route_add
            if (response.status === 'success' && response.action === 'track_document_route_add') {
              this.$alertSuccess({ title: 'เพิ่มติดตามงาน สำเร็จ' });
            } else if (response.status === 'success' && response.action === 'track_document_route') {
              let tracking_status = response.result.tracking_status;
              let tracking_status_text = '';

              switch (tracking_status) {
                case 0:
                  tracking_status_text = "อยู่ใน Tab รอดำเนินการ";
                  break;
                case 1:
                  tracking_status_text = "อยู่ใน Tab กำลังดำเนินการ";
                  break;
                case 2:
                  tracking_status_text = "อยู่ใน Tab งานเสร็จ";
                  break;
                case 3:
                  tracking_status_text = "อยู่ใน Tab ลูกค้ารับไปแล้ว";
                  break;
                case 4:
                  tracking_status_text = "อยู่ใน Tab ยกเลิก";
                  break;
                default:
                  tracking_status_text = "สถานะติดตามไม่ถูกต้อง";
              }
              this.$alertSuccess({ title: 'มีในติดตามแล้ว', text: tracking_status_text });
            } else {
              this.$alertError({ title: 'Error', text: 'Failed to track document.' });
            }

            console.log(response); // Optional: Debugging
          } catch (error) {
            // Handle request errors
            this.$alertError({ title: 'Error', text: 'An error occurred while tracking the document.' });
            console.error(error);
          }
        }
      } catch (error) {
        // Handle the error from the confirmation dialog (if needed)
        console.error('An error occurred in the confirmation dialog:', error);
      }
    },
  },
  watch: {
    customer_name_search: function (val) {
      const customerName = val || '';

      if (this.isSyncingCustomerSearch) return;

      // Trim leading space and wait for the normalized value before searching.
      if (customerName[0] === ' ') {
        this.customer_name_search = customerName.trimStart();
        return;
      }

      if (!this.loading && this.form.customer_id) {
        if (customerName !== this.customerSelectedName) {
          this.startManualCustomerEntry(customerName);
        }
      }

      if (customerName && !this.loading) {
        this.handleCustomerLimit();
      }
    },
    'form.customer_phone_number': function (val) {
      if (this.showPhoneNumber) {
        return;
      }
      if (this.transTimeout) {
        clearTimeout(this.transTimeout);
        this.transTimeout = null;
      }
      if (val.length == 0) {
        this.toggleShowPhoneNumber = true;
      } else if (val.length >= 10) {
        this.transTimeout = setTimeout(() => {
          this.toggleShowPhoneNumber = false;
        }, 5000);
      }
    },
    isEditFilterExpressProduct: async function (newVal, oldVal) {
      if (newVal && !this.loading) {
        await this.main_calculate();
        await this.getExpressProduct();
      }
    },
    'form.discounted_groups_id': function (newVal, oldVal) {
      this.queueExpressProductRefresh(newVal, oldVal);
    },
    'form.car_type': function (newVal, oldVal) {
      this.queueExpressProductRefresh(newVal, oldVal);
      if (
        !this.loading &&
        newVal &&
        oldVal &&
        newVal !== oldVal &&
        this.isSelectedThirdInsuranceCarTypeMismatch
      ) {
        this.showThirdInsuranceCarTypeWarning();
      }
    },
    'form.car_weight': function (newVal, oldVal) {
      this.queueExpressProductRefresh(newVal, oldVal);
    },
    'form.engine_size': function (newVal, oldVal) {
      this.queueExpressProductRefresh(newVal, oldVal);
    },
    'form.extra_fuel': function (newVal, oldVal) {
      this.queueExpressProductRefresh(newVal, oldVal);
    },
    'form.car_fuel': function (newVal, oldVal) {
      this.queueExpressProductRefresh(newVal, oldVal);
    },
    'form.registration_date': function (newVal, oldVal) {
      if (newVal !== oldVal) this.main_calculate();
    },
    'form.taxout_date': function (newVal, oldVal) {
      if (newVal !== oldVal) this.main_calculate();
    },
    'form.tax_filling_date': async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        const taxProductIndex = this.getDocumentQuickProductIndex('tax');
        const previousTaxPrice =
          taxProductIndex === -1
            ? null
            : this.form.product[taxProductIndex].product_price;

        await this.main_calculate();

        if (taxProductIndex === -1) return;

        this.applyTaxProductCalculation(this.form.product[taxProductIndex]);
        if (
          Number(previousTaxPrice) !==
          Number(this.form.product[taxProductIndex].product_price)
        ) {
          this.showVehiclePriceChangeNotice();
        }
      }
    },
    '$route.query.pay': function (newVal, oldVal) {
      if (newVal == 'true' || newVal == true) {
        this.dialogPayChoose = true;
      }
    },
    $route: async function (to, from) {
      const loadGeneration = ++this.documentLoadGeneration;
      const isCurrent = () => this.isDocumentLoadCurrent(loadGeneration);
      this.documentLoadRequestSeq += 1;
      this.customerRequestSeq += 1;
      this.invalidatePendingQuickProductMutations();
      // react to route changes...
      this.loading = true;
      this.formHydrationReady = false;
      this.formHydrationFailed = false;
      this.printRequestGuard.invalidate();
      this.form.branch_id = this.$store.state.selected_branch._id;

      const routeDocumentId = to.params.id || '';
      if (routeDocumentId !== (from.params.id || '')) {
        this.dataPrint = { main_bill: null, split_bill: null };
      }
      this.isUpdate = to.params.id ? true : false;
      if (this.isUpdate) {
        const loadTrace = createDocumentLoadTrace('quotation-route-change');
        try {
          const loaded = await this.getData(routeDocumentId, {
            deferPrint: true,
            manageLoading: false,
            loadTrace,
          });
          if (!loaded || !isCurrent()) return;
          if (
            this.$route.params.id !== routeDocumentId ||
            this.form._id !== routeDocumentId
          ) {
            return;
          }

          // Customer Display: this page's component instance is reused by
          // Vue Router across an in-place navigation between two different
          // documents (no remount, since only the :id param changed - see
          // this $route watcher's own comment). Without this, the mixin's
          // customerDisplayDocumentId would still hold the PREVIOUS
          // document's id, so the next sync would publish that stale id and
          // the publisher's own "did the document change" guard
          // (shared/customer-display/publisher.js setView) would wrongly
          // treat this as the same document - carrying over its rating
          // session (and e.g. an already-shown "ได้รับการประเมินแล้ว" inline
          // confirmation) into an unrelated document. Same call the mixin's
          // own first-load hydration already makes.
          this.customerDisplayMarkSaved();

          if (this.form.status == 1 || this.form.status == 2) {
            this.isEdit = false;
          } else if (this.form.status == 0) {
            this.isUpdate = false;
            this.isEdit = true;
            this.getApprovalById(this.$store.state.profile._id);
          }
          await this.main_calculate();
          if (!isCurrent()) return;
          this.loading = false;
          await this.$nextTick();
          if (!isCurrent()) return;
          loadTrace.mark('document-ready', 'document-response');
          loadTrace.mark('visible', 'document-ready');
          const hydrationRequestSeq = this.documentLoadRequestSeq;

          const printTask = runDeferredDocumentTasks([
            {
              name: 'print-data',
              run: () => this.getDataPrint(routeDocumentId, { requireCurrentRoute: true }),
            },
          ], (error, task) => {
            this.$captureException(error, { source: `quotation.Detail.route.${task}` });
          });

          await runRequiredDocumentTasks([
            {
              name: 'express-products',
              run: () => this.form.status == 0
                ? this.getExpressProduct({ throwOnError: true })
                : Promise.resolve(),
            },
            {
              name: 'third-insurance',
              run: () => this.getThirdInsuranceSubCategory({
                preserveForm: true,
                throwOnError: true,
                requestSeq: hydrationRequestSeq,
              }),
            },
            {
              name: 'insurance',
              run: () => this.getInsuranceSubCategory({
                preserveForm: true,
                requestSeq: hydrationRequestSeq,
              }),
            },
          ]);
          if (!isCurrent()) return;
          this.formHydrationReady = true;
          loadTrace.mark('form-ready', 'visible');

          if (isAutomaticPrintRequest(to.query)) {
            await printTask;
            if (!isCurrent()) return;
            await this.$nextTick();
            if (!isCurrent()) return;
            if (this.$refs.printDocument) this.$refs.printDocument.print();
            this.$route.query.print = false;
          } else if (to.query.pay == 'true' || to.query.pay == true) {
            this.dialogPayChoose = true;
          }
        } catch (error) {
          if (isCurrent()) {
            this.formHydrationFailed = true;
            this.loading = false;
            this.$alertServerError({
              title: (error && error.userMessage) || 'Unable to load quotation',
            });
          }
        }
        return;
      } else {
        // Customer Display: this page's instance is reused by Vue Router for
        // an in-place "new document" navigation (no remount) - without this
        // reset, customerDisplayDocumentId would still hold the previous
        // document's id, and the next sync would wrongly look like the same
        // document to the publisher's change guard (see the matching
        // comment on the isUpdate branch above), leaking e.g. a confirmed
        // inline rating onto this new, unrelated document.
        this.customerDisplayDocumentId = '';
        this.quickProductRoles.third_insurand = false;
        this.customerRequestSeq++;
        this.customerSource = 'manual-entry';
        this.customerSelectedName = '';
        this.customer_name_search = '';
        this.list.filter_customers = [];
        (this.dataPrint = {
          main_bill: null,
          split_bill: null,
        }),
          (this.approvals = null);
        this.car = [];
        this.customer = {
          _id: '',
          name: '',
        };
        this.product_selected = [];
        this.product_all = false;
        this.temp_car = {
          _id: '',
          plate_character: '',
          plate_number: '',
          plate_province: '',
        };
        this.plateNumberTouched = false;
        (this.car_tax = {
          net_tax_price: 0,
          total_tax_price: [0, 0, 0, 0],
          tax_price: [0, 0, 0, 0, 0, 0],
          tax_by_year: [0, 0, 0, 0],
          popup_massage: ['', '', '', '', '', ''],
          late_age: 0,
          car_age: 0,
          tax_year_init: moment()
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DDTHH:mm:ss'),
          tax_year_ended: null,
        }),
          (this.form = {
            approval_id: '',
            approval: '',
            number: '',
            status: 0,
            customer_id: '',
            customer_name: '',
            customer_phone_number: '',
            customer_address: {
              address: '',
              district: '',
              sub_district: '',
              province: '',
              postal_code: '',
            },
            customer_taxpayer_number: '',
            customer_company_branch: '',
            is_delivery_address: false,
            customer_delivery_address: {
              address: '',
              district: '',
              sub_district: '',
              province: '',
              postal_code: '',
            },
            customer_group: '',
            call_alert: false,
            call_remind_renewal: false,
            customer_note: '',
            car_plate_character: '',
            car_plate_number: '',
            car_plate_province: '',
            car_type: 'CT1',
            registration_date: '',
            tax_filling_date: moment()
              .set({ hour: 0, minute: 0, second: 0 })
              .format('YYYY-MM-DDTHH:mm:ss'),
            is_corporation_car: false,
            car_registration_url: '',
            extra_fuel: 0,
            car_fuel: 0,
            car_weight: '',
            engine_size: '',
            is_original_document: false,
            taxout_date: '',
            bill_taxout_date: '',
            branch_id: '',
            document_type: 0,
            customer_branch_office: '',
            date_of_issue: '',
            due_date: '',
            project_name: '',
            pick_up_date: '',
            pick_up_time: '',
            tax_year_init: '',
            tax_year_init: '',
            tax_year_ended: '',
            tax_renewal_end_year: 0,
            tax_renewal_year_count: 0,
            product: [
              {
                category_id: 'PC1',
                discount: 0,
                broker: '',
                name: '',
                price: 0,
                product_id: '',
                product_type: '',
                sku_code: '',
                sku_detail: '',
                sub_category_id: '',
                sub_category_name: '',
                vat: 0,
                vat_price: 0,
                insurance_premium: 0,
                start_date: moment()
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                end_date: moment()
                  .add(1, 'years')
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                product_price: 0,
              },
              {
                category_id: 'PC2',
                discount: 0,
                broker: '',
                name: '',
                sku_code: '',
                price: 0,
                product_id: '',
                product_type: '',
                sub_category_id: '',
                sub_category_name: '',
                type: 0,
                vat: 0,
                vat_price: 0,
                start_date: moment()
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                end_date: moment()
                  .add(1, 'years')
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm:ss'),
                product_price: 0,
              },
              {
                category_id: '',
                discount: 0,
                message_on_select: '',
                name: '',
                price: 0,
                product_id: '',
                product_type: '',
                sub_category_id: '',
                sub_category_name: '',
                vat: 0,
                vat_price: 0,
                insurance_premium: 0,
                product_price: 0,
              },
            ],
            original_document_price: 0,
            total_price: 0,
            total_discount: 0,
            net_price: 0,
            notation: '',
            note: '',
            discounted_groups_id: '',
          });

        this.form.branch_id = this.$store.state.selected_branch._id;
        this.form.date_of_issue = moment().format('YYYY-MM-DDTHH:mm:ss');
        await this.getProduct();
        if (!isCurrent()) return;
        this.form.due_date = moment()
          .add(30, 'days')
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DDTHH:mm:ss');
      }
      await this.getApproval();
      if (!isCurrent()) return;
      await this.getApprovalById(this.$store.state.profile._id);
      if (!isCurrent()) return;

      if (!this.isUpdate) {
        this.formHydrationReady = true;
        this.loading = false;
      }
      if (to.query.pay == 'true' || to.query.pay == true) {
        this.dialogPayChoose = true;
      }
    },
  },
  computed: {
    isSelectedThirdInsuranceCarTypeMismatch() {
      const selected = this.form.product[0].product_id;
      const productId = typeof selected === 'object' && selected
        ? selected.product_id
        : selected;
      return this.isThirdInsuranceCarTypeMismatch(
        this.list_insurance.third_insurance_product.find(
          (product) => product.product_id === productId
        )
      );
    },
    hasCarTaxPopupMessage() {
      return this.car_tax.popup_massage.some((message) => Boolean(message));
    },
    showTaxInfoNotice() {
      return this.form.product.some(
        (item) =>
          item.tag === 'tax_include_fines' ||
          String(item.name || '').trim() === 'ค่าภาษีรถ'
      );
    },
    showProductCheckbox() {
      return ['CT1', 'CT2', 'CT3', 'CT12', 'CT17'].includes(
        this.form.car_type
      );
    },
    formDate_registration() {
      return this.form.registration_date
        ? this.formatDate(this.form.registration_date)
        : '';
    },
    total_price() {
      if (this.form.status != 0 && this.$route.params.id)
        return this.form.total_price;
      let price = 0;
      this.form.product.forEach((product) => {
        price += parseFloat(product.product_price || 0);
      });
      return price;
    },
    total_discount() {
      if (this.form.status != 0 && this.$route.params.id)
        return this.form.total_discount;
      let discount = 0;
      this.form.product.forEach((product) => {
        discount += parseFloat(product.discount || 0);
      });
      return discount;
    },
    vat_price() {
      if (this.form.status != 0 && this.$route.params.id)
        return this.form.vat_price;
      let price = 0;
      this.form.product.slice(2).forEach((product) => {
        if (product.vat == 1) price += parseFloat(product.vat_price || 0);
      });
      return price;
    },
    net_price() {
      if (this.form.status != 0 && this.$route.params.id)
        return this.form.net_price;
      if (this.list.setting) {
        let total_price =
          this.total_price - this.total_discount + this.vat_price;
        return parseFloat(
          this.list.setting.reduce_bill_scrap
            ? Math.floor(total_price).toFixed(2)
            : parseFloat(total_price).toFixed(2)
        );
      } else return 0;
    },
  },
};
</script>

<style lang="scss">
.border-grey {
  border: solid rgb(211, 211, 211) 1px !important;
  border-radius: 5px;
  padding: 10px;
}
.border-white {
  border: solid rgb(255, 255, 255) 1px !important;
  border-radius: 5px;
  padding: 10px;
}

.swal2-icon.swal2-warning {
  border-color: #f27474 !important;
}
.swal2-icon.swal2-warning .swal2-icon-content {
  color: #f27474 !important;
}
.table-style {
  vertical-align: baseline !important;
}
.btn-table-style {
  vertical-align: top !important;
}
.full-width-row {
  width: 100%;
}
.textfield-w150 {
  width: 200px;
}
.align-self-center {
  align-self: center;
}
.document-form-hydrating {
  pointer-events: none;
  opacity: 0.82;
}
</style>

<style src="../responsive.css"></style>
